import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import CKEditor from "react-ckeditor-component";
import $ from 'jquery';
import Header from './../../Header';
import HeaderMob from './../../HeaderMob';
import AutoComplete from 'material-ui/AutoComplete';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Add_request from './../../assets/images/add.png';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
import DatePicker from 'react-datepicker';
import moment from 'moment';
const dataSourceConfig = {
    text: 'title',
    value: 'id',
};
const dataRelationSourceConfig = {
    text: 'title',
    value: 'id',
};
class ViewErTest extends Component {
    constructor(props) {
        super(props);
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
            story_status_name: '120',
            story_status: [],
            side_story_attachments: [],
            story_for_feature: [],
            side_story_details: [],
            story_er: [],
            story_title_error_message: '',
            search_er: '',
            release_notes: [],
            relation_search: [],
            feature_search: [],
            search: [],
            errorText: '',
            reporter: '',
            assigned_to: '',
            assigned_to_for_initiative: '',
            er: [],
            er_initiative: [],
            category: [],
            formatted_owners: [],
            er_attachment: [],
            er_note_attachment: [],
            attachmentnotes: [],
            priority: '',
            owner: '',
            status: [],
            multi_ticket: [],
            tattle_flag: [],
            webUrl: '',
            status_name: '',
            related_er: [],
            linked_er: [],
            related_to: [],
            related_to_any: '',
            related_er_id: '',
            related_category: [],
            related_priority: [],
            related_status: [],
            er_history: [],
            notes: [],
            user_id: '',
            note: '',
            team: '',
            NoteEdit: '',
            end_date: '',
            er_monitor: '',
            monitor_er: [],
            monitoring: '',
            owners: [],
            url: '',
            value: 0,
            images: '',
            er_history: [],
            error: '',
            id_error: '',
            message: '',
            owner: '',
            workflow: [],
            owner_to: '',
            owner_cc: '',
            fields: {},
            errors: {},
            internal_cc: '',
            apiUrl: this.decryptconfigdata('apiUrl'),
            userEmail: has_local_data ? localdata.user_email : '',
            userId: has_local_data ? localdata.user_id : '',
            userName: has_local_data ? localdata.user_name : '',
            userAuthKey: has_local_data ? localdata.user_key : '',
            er_url: window.location.href,
            story_owner: has_local_data ? localdata.user_id : '',
            checked_story_id: {},
            checked_story_length: '',
            scrol: 1,
            start_date: '',
            end_date: '',
            go_live_date: ''
        }
        this.AddNote = this.AddNote.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onStoryLinkChange = this.onStoryLinkChange.bind(this);
        this.onChange1 = this.onChange1.bind(this);
        this.ckOnChange1 = this.ckOnChange1.bind(this);
        this.searchChange = this.searchChange.bind(this)
        this.getSearchERNumber = this.getSearchERNumber.bind(this);
        this.jq = $;
        this.startdateChange = this.startdateChange.bind(this);
        this.enddateChange = this.enddateChange.bind(this);
        this.golivedateChange = this.golivedateChange.bind(this);
        this.onStartSaveClick = this.onStartSaveClick.bind(this);
    }

    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }

    rawjsonparse(findresponse, flg) {
        return findresponse;
    }

    startdateChange(event) {
        this.setState({ startdate: event, start_date: moment(event).format("YYYY-MM-DD") }, function () { });
    }


    enddateChange(event) {
        this.setState({ enddate: event, end_date: moment(event).format("YYYY-MM-DD") }, function () { });
    }

    golivedateChange(event) {
        this.setState({ golivedate: event, go_live_date: moment(event).format("YYYY-MM-DD") }, function () { });
    }
    // 66527: Project plan dates start
    focousOutStartDate(value) {
        if (!value) {
            this.setState({ startdate: '' });
            this.setState({ start_date: '' });
        }
    }
    focousOutEndDate(value) {
        if (!value) {
            this.setState({ enddate: '' });
            this.setState({ end_date: '' });
        }
    }
    focousOutGoLiveDate(value) {
        if (!value) {
            this.setState({ golivedate: '' });
            this.setState({ go_live_date: '' });
        }
    }

    changeProjectDates()
    {
        let errors = {};
        const fd = new FormData;
        document.getElementById("btn_change_dates").disabled = true;
        fd.append('date_reason', this.state.note);
        fd.append('start_date',this.state.start_date);
        fd.append('end_date',this.state.end_date);
        fd.append('go_live_date',this.state.go_live_date);
        fd.append('er_id',this.state.er.id);
        
        fetch(this.state.apiUrl + '/ErRest/changeProjectDates/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                if (findresponse.code == 200) {
                    document.getElementById("btn_change_dates").innerHTML = "Sending....";
                    window.location.href = '/viewEr/' + this.state.er.id;
                } else {
                    errors["reason_msg"] = findresponse.reason_msg;
                    document.getElementById("btn_change_dates").disabled = false;
                    this.setState({ releaseNoteErrorMessage: findresponse.msg });
                    this.setState({ errors: errors });
                }
            })
    }
    // 66527: Project plan dates end
    isValidStoryLink(link) {
        var pattern = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
        return pattern.test(link);
    }

    handleUpdateInput = (searchText) => {
        this.setState({
            searchText: searchText,
        });
        this.getERNumber(searchText);
    };

    handleNewRequest = (searchText) => {
        this.getSearchERNumber();
    };

    handleRelationUpdateInput = (relation_searchText) => {
        this.setState({
            relation_searchText: relation_searchText,
            errors: ''
        });
        this.GetRelatedERNumber(relation_searchText);
    };

    handleRelationNewRequest = (relation_searchText) => { };

    handleFeatureUpdateInput = (feature_searchText) => {
        this.setState({
            feature_searchText: feature_searchText,
        });
        this.GetFeatureERNumber(feature_searchText);
    };

    handleFeatureNewRequest = (feature_searchText) => {
    };

    enterKeyPress(event) {
        if (event.key == 'Enter') {
        }
    }

    GetFeatureERNumber(feature_searchText = '') {
        fetch(this.state.apiUrl + '/ErRest/GetFeatureERNumber/userAuthKey/' + this.state.userAuthKey + '/feature_searchText/' + feature_searchText + '/er_id/' + this.props.match.params.erId, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                if (findresponse.code == 200) {
                    this.setState({
                        feature_search: findresponse.ers,
                        feature_errorText: '',
                    })
                } else {
                    this.setState({ feature_errorText: findresponse.msg })
                }
            })
    }

    GetRelatedERNumber(relation_searchText = '') {
        fetch(this.state.apiUrl + '/ErRest/GetRelatedERNumber/userAuthKey/' + this.state.userAuthKey + '/relation_searchText/' + relation_searchText, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                if (findresponse.code == 200) {
                    this.setState({
                        relation_search: findresponse.ers,
                        relation_errorText: '',
                    })
                } else {
                    this.setState({ relation_errorText: findresponse.msg })
                }
            })
    }

    getERNumber(searchText = '') {
        fetch(this.state.apiUrl + '/ErRest/getERNumber/userAuthKey/' + this.state.userAuthKey + '/searchText/' + searchText, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                if (findresponse.code == 200) {
                    this.setState({
                        search: findresponse.ers,
                        errorText: ''
                    })
                } else {
                    this.setState({ errorText: findresponse.msg })
                }

            })
    }
    getSearchERNumber() {
        fetch(this.state.apiUrl + '/ErRest/getSearchERNumber/userAuthKey/' + this.state.userAuthKey + '/search/' + this.state.searchText, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                if (findresponse.code == 200) {
                    this.setState({
                        ers: findresponse.ers,
                        item_count: findresponse.item_count,
                    })
                    if (this.state.item_count > 0) {
                        window.location.href = '/viewER/' + findresponse.er_id;
                    }
                }
                else {
                    alert("No result found");
                }
            })
    }

    handleChange = (event, index, value) => {
        this.setState({ value: value });
    }

    onStoryLinkChange(event) {
        var btn = document.getElementById("insert_story_link");
        var link = document.getElementById('story_link').value.trim();
        if (document.getElementById('story_link').value.trim() != '' && document.getElementById('story_text').value.trim() != '' && this.isValidStoryLink(link)) {
            btn.disabled = false;
        }
        else {
            btn.disabled = true;
        }
        let fields = this.state.fields;
        fields[event.target.name] = event.target.value;
        this.setState({ [event.target.name]: event.target.value });
    }

    onChangeStoryTitle(propertyName, event) {
        const story_er = this.state.story_er;
        story_er[event.target.name][propertyName] = event.target.value;
        this.setState({ story_er: story_er });
    }

    onChange1(event) {
        if (event.target.name == 'story_id_checkbox') {
            var role = document.getElementsByName('story_id_checkbox');
            var ln = 0;
            this.state.checked_story_id = '';
            for (let i = 0; i < role.length; i++) {
                if (role[i].checked === true) {
                    ln++;
                    this.state.checked_story_id += role[i].value + ",";
                }
            }
            this.setState({ checked_story_length: ln, checked_story_error_message: '' });
        }
        else {
            this.setState({ [event.target.name]: event.target.value });
        }
    }

    onChange(propertyName, event) {
        this.setState({ [event.target.name]: event.target.value });
    }

    searchChange(event) {
        this.setState({ [event.target.name]: event.target.value }, function () {
            this.getLinkedErDetails();
        });
    }

    getFlagColor(flag) {
        switch (flag) {
            case '1':
                return '#ffc600';
            default:
                return '';
        }
    }
    // Er 71186: Change in status workflow, Added 24: QACompleted-PreProd
    getStatusClorClass(status) {
        switch (status) {
            case '128':
                return 'er_sym qa';
            case '127':
                return 'er_sym closed';
            case '126':
                return 'er_sym deferred';
            case '125':
                return 'er_sym blocked';
            case '124':
                return 'er_sym failed';
            case '123':
                return 'er_sym resolved';
            case '122':
                return 'er_sym qa';
            case '121':
                return 'er_sym active';
            case '120':
                return 'er_sym assigned';
            case '109':
                return 'er_sym assigned';
            case '110':
                return 'er_sym assigned';
            case '10':
                return 'er_sym assigned';
            case '50':
                return 'er_sym assigned';
            case '55':
                return 'er_sym active';
            case '60':
                return 'er_sym active';
            case '80':
                return 'er_sym resolved';
            case '82':
                return 'er_sym qa';
            case '83':
                return 'er_sym pm_rev';
            case '84':
                return 'er_sym pm_pass';
            case '85':
                return 'er_sym tested';
            case '88':
                return 'er_sym qa';
            case '90':
                return 'er_sym closed';
            case '91':
                return 'er_sym tospec';
            case '11':
                return 'er_sym active';
            case '13':
                return 'er_sym active';
            case '14':
                return 'er_sym qa';
            case '15':
                return 'er_sym active';
            case '16':
                return 'er_sym resolved';
            case '17':
                return 'er_sym resolved';
            case '18':
                return 'er_sym qa';
            case '19':
                return 'er_sym active';
            case '20':
                return 'er_sym active';
            case '21':
                return 'er_sym assigned';
            case '22':
                return 'er_sym active';
            case '24':
                return 'er_sym resolved';
            case '25':
                return 'er_sym qa';
            case '26':
                return 'er_sym active';
            case '27':
                return 'er_sym resolved';
            case '28':
                return 'er_sym qa';
            case '29':
                return 'er_sym active';
            case '30':
                return 'er_sym resolved';
            default:
                return 'er_sym new';
        }
    }

    handleValidation() {
        let fields = this.state.fields;
        let errors = {};
        let formIsValid = true;
        if (!fields["note"]) {
            formIsValid = false;
            errors["note"] = "This field is required.";
        }
        this.setState({ errors: errors });
        return formIsValid;
    }

    showImage(s3url, filename) {
        // Construct the 'a' element
        var link = document.createElement("a");
        link.download = filename;
        link.target = "_blank";
        // Construct the URI
        link.href = s3url;
        document.body.appendChild(link);
        link.click();
        // Cleanup the DOM
        document.body.removeChild(link);
    }

    downloadImage(id) {
        var win = window.open(this.state.apiUrl + '/ErRest/DownloadImage/id/' + id + '/user_id/' + this.state.userId + '/userAuthKey/' + this.state.userAuthKey, '_blank');
        win.focus()
    }

    getSize(bytes, decimals) {
        if (bytes == 0) return '0 Bytes';
        var k = 1024,
            dm = decimals <= 0 ? 0 : decimals || 2,
            sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
            i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

    getImageTypeClass(filename) {
        var ext = filename.split('.').pop();
        if (ext == filename)
            return "";
        return ext;
    }

    RemoveRelation(related_er_id, er_id) {
        var conf = window.confirm('Are you sure to remove the relation ?');
        if (conf) {
            fetch(this.state.apiUrl + '/ErRest/RemoveRelation/related_er_id/' + related_er_id + '/er_id/' + er_id + '/user_id/' + this.state.userId + '/userAuthKey/' + this.state.userAuthKey)
                .then((Response) => Response.json())
                .then((findresponse) => {
                    this.getErDetails();
                })
        }
    }

    RemoveER(related_er_id, er_id) {
        var conf = window.confirm('Are you sure to remove the ER ?');
        if (conf) {
            fetch(this.state.apiUrl + '/ErRest/RemoveER/related_er_id/' + related_er_id + '/er_id/' + er_id + '/user_id/' + this.state.userId + '/userAuthKey/' + this.state.userAuthKey)
                .then((Response) => Response.json())
                .then((findresponse) => {
                    this.getErDetails();
                })
        }
    }

    RemoveStory(story_id) {
        var conf = window.confirm('Are you sure to remove the Story ?');
        if (conf) {
            fetch(this.state.apiUrl + '/ErRest/RemoveStory/story_id/' + story_id + '/user_id/' + this.state.userId + '/userAuthKey/' + this.state.userAuthKey)
                .then((Response) => Response.json())
                .then((findresponse) => {
                    this.getErDetails();
                })
        }
    }

    setNote(id, note) {
        localStorage.setItem('ticket_note', note);
        this.props.history.push('/NoteEdit/' + id);
    }

   //68456- Issue in Notification on note tagging starts
   ckOnChange1(evt) {
    var ckContent = evt.editor.getData();
    var selection = evt.editor.getSelection();
    var query = '';
   
    var range = selection.getRanges()[0];
    if (range) {
        var cursor_position = range.startOffset;
        var Current_string = range.startContainer.$.data;
        if (Current_string) {
            var changedString = Current_string.substring(0, cursor_position);
            if (changedString.lastIndexOf('@') != -1) {
                query = changedString.substring(changedString.lastIndexOf('@') + 1);

            }

        }
    }

    if (this.state.note.toLowerCase() != ckContent.toLowerCase()) {
        
        this.setState({
            note: ckContent
        });

        var obj = this;
        setTimeout(function () {
            ckContent = ckContent.replace(/<\/p>$/, ""); //remove last </p>
            
            if (query) {
                var result = [];

                var filterObj = obj.state.owners.filter(function (e) {
                    if (e.name.toLowerCase().includes(query.toLowerCase())) {
                        var data = [];
                        data['name'] = e.name;
                        data['email'] = e.email;
                        data['user_type'] = e.user_type;
                        data['id'] = e.id;
                        result.push(data);
                    }
                });

                var size = Object.keys(result).length;

                var mtchitems = '';
                if (size > 0) {
                    
                    for (var i in result) {

                        mtchitems += '<li class="auto-suggest-li" style="padding:5px;cursor:pointer;background:#ccc;margin-bottom:1px;" data-id = "'+ result[i]['id'] +'" data-email = "'+ result[i]['email'] +'" data-user_type = "'+ result[i]['user_type'] +'"  >' + result[i]['name'] + '</li>';
                    }
                     
                    mtchitems = '<ul style="list-style:none" class="auto-suggest-ul">' + mtchitems + '</ul>';
                            
                    document.getElementById('note_autoseggestion').innerHTML = mtchitems;

                    $('.auto-suggest-li').on('click', function (event) {

                        var id = $(this).data('id');
                        var email = $(this).data('email');
                        var user_type = $(this).data('user_type');
                       
                        //Important !!! Need to change the Site URL
                        if(user_type == 0){

                            var final_string = '<a href= "https://intranet.muvi.com/viewEmployee/'+ id +'" class="mentions" data-id = "'+ id +'" >@' +  event.target.innerText.trim() + '</a>';

                        }else{

                            var final_string = '<a href= "https://intranet.muvi.com/viewGroups/'+ email +'" class="mentions" data-id = "'+ id +'" >@' +  event.target.innerText.trim() + '</a>';
                        }
                        
                        evt.editor.insertHtml(final_string);

                        final_string = evt.editor.getData();

                        console.log(final_string);

                        var replaceQueryString = final_string.replace('@' + query, '');
                        
                        console.log(replaceQueryString);
                        //replaceQueryString = replaceQueryString.split('tagged-email-data').join('tagged-email-data"  data-cke-saved-href="#');
                        
                        evt.editor.setData(replaceQueryString);
                        
                        

                        document.getElementById('note_autoseggestion').innerHTML = "";
                         evt.editor.focus();
                    });
                    
                } else {
                    document.getElementById('note_autoseggestion').innerHTML = "";
                }
            } else {
                document.getElementById('note_autoseggestion').innerHTML = "";
            }
        }, 300);
    } else {
        evt.editor.focus();
    }
    }   
    //68456- Issue in Notification on note tagging ends

    NoteEditCondition(id, note) {
        return (
            <a href="#" onClick={() => this.setNote(id, note)}> <i class="fa fa-edit"></i></a>
        )
    }

    getReporter() {
        if (this.state.reporter) {
            return (
                <div class="er_moniter">
                    <div class="text-inded"><Link to={`/viewEmployee/${this.state.reporter}`} name={"max"}>{this.state.formatted_owners[this.state.reporter].name}</Link></div>
                    <div class="pro_image pull-left">
                        <Link to={`/viewEmployee/${this.state.reporter}`} name={"max"}>
                            {this.state.formatted_owners[this.state.reporter].attachment_url ? <img src={this.state.formatted_owners[this.state.reporter].attachment_url + this.state.formatted_owners[this.state.reporter].attachment} /> : <span class="profile_first_name">{this.state.formatted_owners[this.state.reporter].img_name}</span>}
                        </Link>
                    </div>
                </div>
            )
        }
    }

    getAssignedTo() {
        if (this.state.assigned_to) {
            return (
                <div class="er_moniter">
                    <div class="text-inded"><Link to={`/viewEmployee/${this.state.assigned_to}`} name={"max"}>{this.state.formatted_owners[this.state.assigned_to].name}</Link></div>
                    <div class="pro_image pull-left">
                        <Link to={`/viewEmployee/${this.state.assigned_to}`} name={"max"}>
                            {this.state.formatted_owners[this.state.assigned_to].attachment_url ? <img src={this.state.formatted_owners[this.state.assigned_to].attachment_url + this.state.formatted_owners[this.state.assigned_to].attachment} /> : <span class="profile_first_name">{this.state.formatted_owners[this.state.assigned_to].img_name}</span>}
                        </Link>
                    </div>
                </div>
            )
        }

    }

    getAssignedToForInitiative() {
        if (this.state.assigned_to_for_initiative) {
            return (
                <div class="er_moniter">
                    <div class="text-inded">{this.state.formatted_owners[this.state.assigned_to_for_initiative].name}</div>

                    <div class="pro_image pull-left">
                        {this.state.formatted_owners[this.state.assigned_to_for_initiative].attachment_url ? <img src={this.state.formatted_owners[this.state.assigned_to_for_initiative].attachment_url + this.state.formatted_owners[this.state.assigned_to_for_initiative].attachment} /> : <span class="profile_first_name">{this.state.formatted_owners[this.state.assigned_to].img_name}</span>}
                    </div>
                </div>
            )
        }
    }

    getErDetails() {
        $(document).ready(function () {
            $('.loader-new').removeClass('hidden');
            $('.intranet_body').addClass('hidden');
        });
        fetch(this.state.apiUrl + '/ErRest/viewEr/id/' + this.props.match.params.erId + '/userId/' + this.state.userId + '/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((responseJson) => {
                responseJson = this.rawjsonparse(responseJson, 1);
                $(document).ready(function () {
                    $('.loader-new').addClass('hidden');
                    $('.intranet_body').removeClass('hidden');
                });
                //Here to set into local storage those ids visited
                var max_recentlyview = responseJson.recentlyview;
                if (localStorage.getItem('recentlyview')) {
                    var tmp = localStorage.getItem('recentlyview').split(',');
                    //Here to check if maximum length been exceeded, lets remove old data
                    if (tmp.length > max_recentlyview) {
                        //Here let's remove olld data
                        var rmv_indexes = (tmp.length - max_recentlyview) + 1;
                        tmp.splice(0, rmv_indexes)
                        if (tmp.includes(this.props.match.params.erId)) {
                            localStorage.setItem('recentlyview', tmp);
                        } else {
                            tmp.push(this.props.match.params.erId);
                            localStorage.setItem('recentlyview', tmp);
                        }
                    } else {
                        //Here to check if the same id in the list or not
                        if (tmp.includes(this.props.match.params.erId)) {
                        } else {
                            //Here let's push that id into array
                            tmp.push(this.props.match.params.erId);
                            localStorage.setItem('recentlyview', tmp);
                        }
                    }
                } else {
                    var recentlyview = new Array();
                    recentlyview.push(this.props.match.params.erId);
                    localStorage.setItem('recentlyview', recentlyview)
                }
                //Here to assign the recently viewed items into state
                if (localStorage.getItem('recentlyview')) {
                    var tmprecnt = localStorage.getItem('recentlyview').split(',');
                    var obj = this;
                    this.setState({
                        recentlyview: tmprecnt
                    });
                }
                //End
                if (responseJson.id_error == 1) {
                } else {
                    console.log(responseJson)
                    this.setState({
                        reporter: responseJson.reporter,
                        assigned_to: responseJson.assigned_to,
                        er: responseJson.er,
                        notes: responseJson.notes,
                        er_history: responseJson.er_history,
                        ownername: responseJson.ownername,
                        userid: responseJson.userid,
                        id_error: responseJson.id_error,
                        owners: responseJson.owners,
                        er_attachment: responseJson.er_attachment,
                        config: responseJson.config,
                        er_note_attachment: responseJson.er_note_attachment,
                        formatted_owners: responseJson.formatted_owners,
                        attachmentnotes: responseJson.attachmentnotes,
                        status_name: responseJson.er.status,
                        workflow: responseJson.workflow,
                        related_er: responseJson.related_er,
                        related_category: responseJson.related_category,
                        related_priority: responseJson.related_priority,
                        related_status: responseJson.related_status,
                        monitor_er: responseJson.monitor_er,
                        owners: responseJson.owner,
                        team: responseJson.team,
                        product_line: responseJson.product_line,
                        category: responseJson.category,
                        type: responseJson.type,
                        priority: responseJson.priority,
                        status: responseJson.status,
                        server: responseJson.server,
                        related_to: responseJson.related_to,
                        er_history: responseJson.er_history,
                        release_notes: responseJson.release_notes,
                        is_release_notes: responseJson.is_release_notes,
                        linked_er: responseJson.linked_er,
                        story_er: responseJson.story_er,
                        bug_feature_category_workflow: responseJson.bug_feature_category_workflow,
                        story_status: responseJson.story_status,
                        multi_ticket: responseJson.er.multi_ticket,
                        scrol: this.state.scrol + 1,
                        tattle_flag: responseJson.er.tattle_flag,
                        webUrl: responseJson.webUrl,
                    })
                    if (this.state.er.date_start) {
                        let x = Date.parse(this.state.er.date_start);
                        this.setState({ startdate: moment(x) })
                    }
                    if (this.state.er.date_end) {
                        let x = Date.parse(this.state.er.date_end);
                        this.setState({ enddate: moment(x) })
                    }
                    if (this.state.er.date_go_live) {
                        let x = Date.parse(this.state.er.date_go_live);
                        this.setState({ golivedate: moment(x) })
                    }
                    if (this.state.er.date_created) {
                        let x = Date.parse(this.state.er.date_created);
                        this.setState({ createddate: moment(x) })
                    }
                }
                if (responseJson.error == 1) {
                    window.location.href = '/Unauthorized';
                }

                if (this.state.scrol <= 2) {

                    const { location: { pathname, hash } } = this.props;
                    const element = document.getElementById(hash.replace("#", ""));

                    setTimeout(() => {
                        window.scrollTo({
                            behavior: element ? "smooth" : 'auto',
                            top: element ? element.offsetTop : 0
                        })
                    })
                }
                else {
                    return false;
                }
            })
    }

    getLinkedErDetails() {
        fetch(this.state.apiUrl + '/ErRest/viewEr/id/' + this.props.match.params.erId + '/userId/' + this.state.userId + '/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((responseJson) => {
                responseJson = this.rawjsonparse(responseJson, 1);
                if (responseJson.id_error == 1) {
                } else {
                    console.log(responseJson)
                    this.setState({
                        linked_er: responseJson.linked_er,
                    })
                }
            })
    }

    AddNote(from_pause="") {
        let errors = {};
        document.getElementById("add_note").innerHTML = "Sending....";
        let img = document.getElementById('attachments').files.length;
        const fd = new FormData;
        if (img > 0) {
            for (var x = 0; x < img; x++) {
                fd.append("image[]", document.getElementById('attachments').files[x]);
            }
        }
        document.getElementById("add_note").disabled = true;
        fd.append('note', this.state.note);
        fd.append('er_id', this.props.match.params.erId);
        //Er 66487: Pause Status>> pause button on viewEr page
        if(from_pause !='' &&  from_pause == 21)
        {
            fd.append('from_pause', from_pause);
            document.getElementById("btn_change_er_pause").disabled = true;
        }
        fetch(this.state.apiUrl + '/ErRest/AddNote/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                document.getElementById("add_note").disabled = false;
                document.getElementById("add_note").innerHTML = "Add Note";
                if (findresponse.code == 200) {
                    if(from_pause !='' &&  from_pause == 21)
                    {
                        document.getElementById("btn_change_er_pause").innerHTML = "Sending....";
                    }
                    this.setState({ message: findresponse.msg }, function () {
                        errors["note"] = "";
                        this.setState({ errors: errors });
                        window.location.href = '/viewEr/' + this.state.er.id;
                    });
                } else {
                    if(from_pause !='' &&  from_pause == 21)
                    {
                        errors["reason_error"] = findresponse.reason_msg;
                        document.getElementById("btn_change_er_pause").disabled = false;
                    }
                    else{
                        errors["note"] = findresponse.msg;
                    }
                    this.setState({ errors: errors });
                    this.setState({ message: findresponse.msg })
                }
            })
    }

    insertReleaseNote() {
        const fd = new FormData;
        document.getElementById("insert_release_note").disabled = true;
        fd.append('ticket_inputs', JSON.stringify(this.state));
        fetch(this.state.apiUrl + '/ErRest/insertReleaseNote/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                if (findresponse.code == 200) {
                    document.getElementById("insert_release_note").innerHTML = "Sending....";
                    window.location.href = '/viewEr/' + this.state.er.id;
                } else {
                    document.getElementById("insert_release_note").disabled = false;
                    this.setState({ releaseNoteErrorMessage: findresponse.msg })
                }
            })
    }

    InsertRelatedToER() {
        let errors = {};
        var related_er_id = document.getElementById('related_er_id').value;
        if (related_er_id) {
            const fd = new FormData;
            fd.append('ticket_inputs', JSON.stringify(this.state));
            fetch(this.state.apiUrl + '/ErRest/InsertRelatedToER/id/' + this.props.match.params.erId + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
                method: 'POST',
                dataType: 'json',
                body: fd,
            })
                .then((Response) => Response.json())
                .then((findresponse) => {
                    findresponse = this.rawjsonparse(findresponse, 1);
                    if (findresponse.code == 200) {
                        this.setState({ message: findresponse.msg }, function () {
                            this.getErDetails();
                            errors["related_er"] = "";
                            this.setState({ errors: errors });
                        });
                    } else {
                        errors["related_er"] = findresponse.msg;
                        this.setState({ errors: errors });
                    }
                })
        } else {
            errors["related_er"] = "This field is required.";
            this.setState({ errors: errors });
            return false;
        }
    }

    addFlag(id) {
        fetch(this.state.apiUrl + '/ErRest/UpdateFlag/id/' + id + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                if (findresponse.code == 200) {
                    this.getErDetails();
                    document.getElementById("flag_true_button").click();
                }
            })
    }

    removeFlag(id) {
        fetch(this.state.apiUrl + '/ErRest/RemoveFlag/id/' + id + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                if (findresponse.code == 200) {
                    this.getErDetails();
                    document.getElementById("flag_false_button").click();
                }
            })
    }

    InsertMonitorER() {
        let errors = {};
        if (this.state.value.length === undefined || this.state.value.length === 0) {
            errors["monitor"] = "This field is required.";
            this.setState({ errors: errors });
            return false;
        } else {
            const fd = new FormData;
            fd.append('ticket_inputs', JSON.stringify(this.state));
            fetch(this.state.apiUrl + '/ErRest/InsertMonitorER/id/' + this.props.match.params.erId + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
                method: 'POST',
                dataType: 'json',
                body: fd,
            })
                .then((Response) => Response.json())
                .then((findresponse) => {
                    findresponse = this.rawjsonparse(findresponse, 1);
                    if (findresponse.code == 200) {
                        this.setState({ message: findresponse.msg }, function () {
                            this.getErDetails();
                            this.state.value = '';
                            errors["monitor"] = "";
                            this.setState({ errors: errors });
                        });
                    } else {
                        this.setState({ message: findresponse.msg })
                    }
                })
        }
    }

    getSelectedCcOwner() {
        var selectedCcValues = [];
        $("#ccselectlist :selected").each(function () {
            selectedCcValues.push($(this).val());
        });
        this.setState({ internal_cc: selectedCcValues });
    }

    close_er(id) {
        if (window.confirm('Are you sure close this ER ?')) {
            fetch(this.state.apiUrl + '/ErRest/ErClose/id/' + this.props.match.params.erId + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
                method: 'POST',
                dataType: 'json',
                body: JSON.stringify(this.state),
            })
                .then((Response) => Response.json())
                .then((findresponse) => {
                    this.getErDetails();
                })
        }
    }

    InsertUserImage() {
        const fd = new FormData;
        fd.append('ticket_inputs', JSON.stringify(this.state));
        fetch(this.state.apiUrl + '/ErRest/InsertUserImage/id/' + this.props.match.params.erId + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                if (findresponse.code == 200) {
                    this.setState({ message: findresponse.msg }, function () {
                        window.location.href = '/er/' + this.props.match.params.erId;
                    });
                } else {
                    this.setState({ message: findresponse.msg })
                }
            })
    }

    delteimage(id, er_id) {
        if (window.confirm('Are you sure to delete ?')) {
            fetch(this.state.apiUrl + '/ErRest/deleteErImage/id/' + id + '/er_id/' + er_id + '/userId/' + this.state.userId + '/userAuthKey/' + this.state.userAuthKey + '/username/' + this.state.userName)
                .then((Response) => Response.json())
                .then((findresponse) => {
                    this.getErDetails();
                })
        }
    }

    delteStoryimage(id, story_id, name) {
        if (window.confirm('Are you sure to delete ' + name + ' ?')) {
            fetch(this.state.apiUrl + '/ErRest/deleteStoryImage/id/' + id + '/er_id/' + story_id + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId)
                .then((Response) => Response.json())
                .then((findresponse) => {
                    this.getErDetails();
                    this.openStoryNav(story_id)
                })
        }
    }

    deleteMonitor(monitor_id, monitor_name) {
        if (window.confirm('Are you sure to remove ' + monitor_name + ' ?')) {
            fetch(this.state.apiUrl + '/ErRest/DeleteMonitor/id/' + this.props.match.params.erId + '/userAuthKey/' + this.state.userAuthKey + '/monitor_id/' + monitor_id, {
                method: 'POST',
                dataType: 'json',
                body: JSON.stringify(this.state),
            })
                .then((Response) => Response.json())
                .then((findresponse) => {
                    findresponse = this.rawjsonparse(findresponse, 1);
                    if (findresponse.code == 200) {
                        this.getErDetails();
                    }
                })
        }
    }

    onToggle(obj) {
        var obj = document.getElementById('showmore')
        if (obj.classList.contains('collapsed')) {
            obj.innerHTML = 'More Details >>';
        } else {
            obj.innerHTML = 'Hide Details >>';
        }
    }

    onToggleStory() {
        var obj = document.getElementById('showmorestory')
        if (obj.classList.contains('collapsed')) {
            obj.innerHTML = 'View More <i class="fa fa-angle-down" aria-hidden="true"></i>';
        } else {
            obj.innerHTML = 'View Less <i class="fa fa-angle-up" aria-hidden="true"></i>';
        }
    }

    openNav(er_id) {
        document.getElementById("mySidenav").style.width = "320px";
        fetch(this.state.apiUrl + '/ErRest/viewInitiativeEr/id/' + er_id + '/userId/' + this.state.userId + '/userAuthKey/' + this.state.userAuthKey)
            .then((Response) => Response.json())
            .then((responseJson) => {
                responseJson = this.rawjsonparse(responseJson, 1);
                this.setState({
                    er_initiative: responseJson.er_initiative,
                    assigned_to_for_initiative: responseJson.assigned_to_for_initiative,
                    story_for_feature: responseJson.story_for_feature,
                })
            })
    }

    openStoryNav(story_id, sequence_no) {
        const fd = new FormData;
        document.getElementById("storySidenav").style.width = "320px";
        fd.append('sequence_no', sequence_no);
        fetch(this.state.apiUrl + '/ErRest/viewSideStoryEr/id/' + story_id + '/userId/' + this.state.userId + '/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((responseJson) => {
                responseJson = this.rawjsonparse(responseJson, 1);
                $(document).ready(function () {
                    // Configure/customize these variables.
                    var showChar = 100;  // How many characters are shown by default
                    var ellipsestext = "...";
                    var moretext = "Show more >";
                    var lesstext = "Show less";

                    $('.more_details').each(function () {
                        var content = $(this).html();
                        if (content.length > showChar) {
                            var c = content.substr(0, showChar);
                            var h = content.substr(showChar, content.length - showChar);
                            var html = c + '<span class="moreellipses">' + ellipsestext + '&nbsp;</span><span class="morecontent"><span>' + h + '</span>&nbsp;&nbsp;<a href="" class="morelink">' + moretext + '</a></span>';
                            $(this).html(html);
                        }
                    });

                    $(".morelink").click(function () {
                        if ($(this).hasClass("less")) {
                            $(this).removeClass("less");
                            $(this).html(moretext);
                        } else {
                            $(this).addClass("less");
                            $(this).html(lesstext);
                        }
                        $(this).parent().prev().toggle();
                        $(this).prev().toggle();
                        return false;
                    });
                });
                this.setState({
                    side_story_details: responseJson.side_story_details,
                    side_story_attachments: responseJson.side_story_attachments,
                    side_story_sequence_no: responseJson.side_story_sequence_no,
                })
            })
    }

    storyId(story_id) {
        document.getElementById('story_list_text_' + story_id).classList.remove("hidden");
        document.getElementById('er_story_list_title' + story_id).classList.add("hidden");
    }

    onStoryTextClick(story_id) {
        let errors = {};
        document.getElementById('story_list_text_' + story_id).classList.add("hidden");
        document.getElementById('er_story_list_title' + story_id).classList.remove("hidden");
        errors["storyTitle_error_" + story_id] = "";
        this.setState({ errors: errors });
    }

    onSubmitStoryTitleClick(story_id, sequence_no) {
        let errors = {};
        const fd = new FormData;
        var title = document.getElementById('story_title_text_' + story_id).value
        fd.append('title', title);
        fd.append('sequence_no', sequence_no);
        if (title.trim() != '' && title.length != 0) {
            fetch(this.state.apiUrl + '/ErRest/ChangeStoryTitle/id/' + story_id + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
                method: 'POST',
                dataType: 'json',
                body: fd,
            })
                .then((Response) => Response.json())
                .then((findresponse) => {
                    findresponse = this.rawjsonparse(findresponse, 1);
                    if (findresponse.code == 200) {
                        this.setState({ message: findresponse.msg, errors: '' }, function () {
                            this.getErDetails();
                            document.getElementById('story_list_text_' + story_id).classList.add("hidden");
                            document.getElementById('er_story_list_title' + story_id).classList.remove("hidden");
                        });
                    }
                })
        }
        else {
            errors['storyTitle_error_' + story_id] = "This field is required.";
            this.setState({ errors: errors });
        }
    }

    closeNav() {
        document.getElementById("mySidenav").style.width = "0";
    }

    closeStoryNav() {
        document.getElementById("storySidenav").style.width = "0";
        this.setState({
            side_story_details: '',
            side_story_attachments: '',
            side_story_sequence_no: '',
        })
    }

    componentWillMount() {
        document.title = this.props.match.params.erId;
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }

        this.getErDetails();
        $(document).ready(function () {
            if (window.File && window.FileList && window.FileReader) {
                $("#files").on("change", function (e) {
                    var files = e.target.files,
                        filesLength = files.length;
                });
            } else {
                alert("Your browser doesn't support to File API")
            }
            $('.upload_btn label').click(function () {
                $(this).parent().find('.inputfile').click();
            });

            $(".copystory_link").mouseover(function () {
                $(".copy_tooltip").text('copy')
            });

            $('.copystory_link').on('click', function () {
                $(".copy_tooltip").text('copied')
            });

            $('.inputfile').each(function () {
                var $input = $(this),
                    $label = $input.next('label'),
                    labelVal = $label.html();
                $input.on('change', function (e) {
                    var fileName = '';
                    if (this.files && this.files.length > 1)
                        fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
                    else if (e.target.value)
                        fileName = e.target.value.split('\\').pop();
                    if (fileName)
                        $label.find('span').html(fileName);
                    else
                        $label.html(labelVal);
                });
                // Firefox bug fix
                $input
                    .on('focus', function () { $input.addClass('has-focus'); })
                    .on('blur', function () { $input.removeClass('has-focus'); });
            });
            //Show More
            $('.show-more').on('click', function () {
                if ($(this).parent().find('.hide_mob').hasClass('active')) {
                    $(this).parent().find('.hide_mob').removeClass('active');
                }
                else {
                    $(this).parent().find('.hide_mob').addClass('active');
                }
                $('.show-more span').text() === 'Show Less' ? $('.show-more span').text('Show More') : $('.show-more span').text('Show Less');
                $('.show-more .fa').toggleClass('active');
            });

            $('.add_moniter').on('click', function () {
                if ($(this).parent().find('.add_moniter_box').hasClass('active')) {
                    $(this).parent().find('.add_moniter_box').removeClass('active');
                }
                else {
                    $(this).parent().find('.add_moniter_box').addClass('active');
                }
            });
        });

        $('.searchTicket.dept').on('click', function () {
            $(this).closest('.customer').find('.filter_dept').slideToggle('slow');
        });
    }
    ChangeAllOwners() {
        const fd = new FormData;
        var owner = document.getElementById('owner').value;
        fd.append('assign_to', owner);
        fetch(this.state.apiUrl + '/ErRest/ChangeOwners/id/' + this.props.match.params.erId + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                if (findresponse.code == 200) {
                    this.setState({ message: findresponse.msg }, function () {
                        this.getErDetails();
                    });
                } else {
                    this.setState({ message: findresponse.msg })
                }
            })
    }

    ChangeStoryOwners() {
        var isAllCheck = false;
        if (this.state.checked_story_length != '' || this.state.checked_story_length != 0) {
            document.getElementById('story_assign_to_button').disabled = true;
            document.getElementById('story_assign_to_button').innerHTML = 'Assigning';
            const fd = new FormData;
            fd.append('story_ids', this.state.checked_story_id);
            fd.append('story_owner', this.state.story_owner);
            fetch(this.state.apiUrl + '/ErRest/ChangeMultipleStoryOwners/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
                method: 'POST',
                dataType: 'json',
                body: fd,
            })
                .then((Response) => Response.json())
                .then((findresponse) => {
                    findresponse = this.rawjsonparse(findresponse, 1);
                    document.getElementById('story_assign_to_button').innerHTML = 'Assign To';
                    if (findresponse.code == 200) {
                        var cbarray = document.getElementsByClassName('story_id_checkbox');
                        for (var i = 0; i < cbarray.length; i++) {
                            if (isAllCheck == false) {
                                cbarray[i].checked = false;
                            } else {
                                cbarray[i].checked = true;
                            }
                        }
                        this.setState({ checked_story_id: '', checked_story_length: 0, checked_story_error_message: '' }, function () {
                            this.props.history.push('/viewEr/' + this.props.match.params.erId);
                            document.getElementById('story_assign_to_button').disabled = false;
                        });
                    } else {
                        document.getElementById('story_assign_to_button').disabled = false
                    }
                })
        }
        else {
            this.setState({ checked_story_error_message: 'Please Check Story' })
        }
    }

    //Er 66422 New Er Status & workflow
    ChangeErToPaused() {
        this.AddNote(21);
        //i.e. change status to 21=pause
    }
 
    ResumeEr()
    {
        this.ChangeAllStatus(23);
        // 23 is Resume status, added only as a flag, will not be saved in DB
    }
    
    //Er 66487: Pause Status Er
    ChangeAllStatus(pause_status='') {
        const fd = new FormData;
        var status = (pause_status == '')?(document.getElementById('status').value):pause_status;
        fd.append('status', status);
        if(pause_status == 23)
        {
            // disabled for restricting multiple clicks
            document.getElementById('resume_button').disabled = true;
        }
        fetch(this.state.apiUrl + '/ErRest/ChangeStatus/id/' + this.props.match.params.erId + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                if (findresponse.code == 200) {
                    if(pause_status == 23)
                    {
                        document.getElementById('resume_button').disabled = false;
                    }
                    this.setState({ message: findresponse.msg }, function () {
                        this.getErDetails();
                    });
                } else {
                    this.setState({ message: findresponse.msg })
                }
            })
    }

    ChangeStoryStatus() {
        var isAllCheck = false;
        if (this.state.checked_story_length != '' || this.state.checked_story_length != 0) {
            document.getElementById('story_status_button').disabled = true;
            document.getElementById('story_status_button').innerHTML = 'Changing';
            const fd = new FormData;
            fd.append('story_ids', this.state.checked_story_id);
            fd.append('story_status_name', this.state.story_status_name);
            fetch(this.state.apiUrl + '/ErRest/ChangeMultipleStoryStatus/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
                method: 'POST',
                dataType: 'json',
                body: fd,
            })
                .then((Response) => Response.json())
                .then((findresponse) => {
                    findresponse = this.rawjsonparse(findresponse, 1);
                    document.getElementById('story_status_button').innerHTML = 'Change Status';
                    if (findresponse.code == 200) {
                        var cbarray = document.getElementsByClassName('story_id_checkbox');
                        for (var i = 0; i < cbarray.length; i++) {
                            if (isAllCheck == false) {
                                cbarray[i].checked = false;
                            } else {
                                cbarray[i].checked = true;
                            }
                        }
                        this.setState({ checked_story_id: '', checked_story_length: 0, checked_story_error_message: '' }, function () {
                            document.getElementById('story_status_button').disabled = false;
                            this.getErDetails();
                        });
                    } else {
                        document.getElementById('story_status_button').disabled = false
                    }
                })
        }
        else {
            this.setState({ checked_story_error_message: 'Please Check Story' })
        }
    }

    moveStoryToFeature() {
        var isAllCheck = false;
        document.getElementById('move_story_button').disabled = true
        const fd = new FormData;
        fd.append('ticket_inputs', JSON.stringify(this.state));
        fd.append('story_ids', this.state.checked_story_id);
        fetch(this.state.apiUrl + '/ErRest/MoveStoryToFeature/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId + '/id/' + this.props.match.params.erId, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                document.getElementById('move_story_button').disabled = false
                if (findresponse.code == 200) {
                    var cbarray = document.getElementsByClassName('story_id_checkbox');
                    for (var i = 0; i < cbarray.length; i++) {
                        if (isAllCheck == false) {
                            cbarray[i].checked = false;
                        } else {
                            cbarray[i].checked = true;
                        }
                    }
                    this.setState({ checked_story_id: '', checked_story_length: 0, checked_story_error_message: '' }, function () {
                        document.getElementById('story_assign_to_button').disabled = false;
                        window.location.href = '/viewEr/' + this.props.match.params.erId;
                    });
                } else {
                    this.setState({ move_story_error_message: findresponse.msg })
                }
            })
    }

    MoveStoryErrorMsg() {
        this.setState({ checked_story_error_message: 'Please Check Story' })
    }

    getStatusClass(status) {
        switch (status) {
            case '128':
                return 'qa';
            case '127':
                return 'closed';
            case '126':
                return 'deferred';
            case '125':
                return 'blocked';
            case '124':
                return 'failed';
            case '123':
                return 'resolved';
            case '122':
                return 'qa';
            case '121':
                return 'active';
            case '120':
                return 'assigned';
            case '110':
                return 'assigned';
            case '109':
                return 'assigned';
            case '10':
                return 'assigned';
            case '50':
                return 'assigned';
            case '55':
                return 'active';
            case '60':
                return 'active';
            case '80':
                return 'resolved';
            case '82':
                return 'qa';
            case '83':
                return 'pm_rev';
            case '84':
                return 'pm_pass';
            case '85':
                return 'tested';
            case '88':
                return 'qa';
            case '11':
                return 'active';
            case '13':
                return 'active';
            case '14':
                return 'qa';
            case '15':
                return 'active';
            case '16':
                return 'resolved';
            case '17':
                return 'resolved';
            case '18':
                return 'qa';
            case '19':
                return 'active';
            case '20':
                return 'active';
            case '21':
                return 'assigned';
            case '22':
                return 'active';
            case '24':
                return 'resolved';
            case '25':
                return 'qa';
            case '26':
                return 'active';
            case '27':
                return 'resolved';
            case '28':
                return 'qa';
            case '29':
                return 'active';
            case '30':
                return 'resolved';
            case '90':
                return 'closed';
            default:
                return 'new';
        }
    }

    goToErDetails(id, assigned_to, owner) {
        window.location.href = '/viewEr/' + id;
    }

    goToStoryDetails(id, assigned_to, owner, sequence_no) {
        window.location.href = '/viewStory/' + id + '/sequence/' + sequence_no;
    }

    getUsersMenu(related_er_id, er_id) {
        return (
            <div class="icon_align">
                <Link class="edit" to={`/EditFeatureCategoryEr/${related_er_id}`} name={"max"}><i class="fa fa-pencil-square-o" aria-hidden="true"></i></Link>
                <span class="icon_delete"><i class="fa fa-trash" onClick={() => this.RemoveER(related_er_id, er_id)}></i></span>
            </div>
        )
    }

    getStoryMenu(story_id) {
        return (
            <ul class="onclick-menu-content">
                <li><span class="icon_delete"><i class="fa fa-trash" onClick={() => this.RemoveStory(story_id)}></i></span></li>
            </ul>
        )
    }

        showhelpdeskid(id) {
        if (id != '') {
               var check_id = id.replace(/^0+/, '');
               check_id = check_id.length;
                var preview_url = `${this.state.webUrl}tattle/support-ticket/`;
            
            var win = window.open(preview_url + id, '_blank');
            win.focus()
        }
    }

    showTab(category) {
        if (category == 64 || category == 12 || category == 77 || category == 136) {
            return 'tickets tab-pane '
        } else {
            return 'tickets tab-pane active'
        }
    }

    insertStory() {
        const fd = new FormData;
        document.getElementById("input_story_button").disabled = true;

        let img = document.getElementById('story_attachment').files.length;
        if (img > 0) {
            for (var x = 0; x < img; x++) {
                fd.append("story_attachment[]", document.getElementById('story_attachment').files[x]);
            }
        }

        fd.append('input_story', this.state.input_story !== '' && typeof this.state.input_story !== 'undefined' ? this.state.input_story : '');
        fd.append('input_story_desc', this.state.input_story_desc !== '' && typeof this.state.input_story_desc !== 'undefined' ? this.state.input_story_desc : '');
        fd.append('story_text', this.state.story_text !== '' && typeof this.state.story_text !== 'undefined' ? this.state.story_text : '');
        fd.append('story_link', this.state.story_link !== '' && typeof this.state.story_link !== 'undefined' ? this.state.story_link : '');
        fetch(this.state.apiUrl + '/ErRest/InsertStory/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId + '/featureId/' + this.props.match.params.erId, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })

            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                document.getElementById("input_story_button").disabled = false;
                if (findresponse.code == 200) {
                    document.getElementById('input_story').value = '';
                    document.getElementById('input_story_desc').value = '';
                    this.setState({ input_story: '', input_story_desc: '' })
                    window.location.href = '/viewEr/' + this.props.match.params.erId;
                    this.setState({ story_title_error_message: '' })
                } else {
                    this.setState({ story_title_error_message: findresponse.msg })
                }
            })
    }

    copylink(id) {
        var selectText = window.location.origin.toString() + '/viewEr/' + id;
        var input = document.createElement('input');
        input.value = selectText;
        document.body.appendChild(input);
        input.select();
        document.execCommand("copy");
        document.body.removeChild(input);
    }

    copystorylink(erId, sequence_no) {
        var selectText = window.location.origin.toString() + '/viewStory/' + erId + '/sequence/' + sequence_no;
        var input = document.createElement('input');
        input.value = selectText;
        document.body.appendChild(input);
        input.select();
        document.execCommand("copy");
        document.body.removeChild(input);
    }

    goBack() {
        window.history.back();
    }

    onStartDateTextClick() {
        if (this.state.er.date_start) {
            let x = Date.parse(this.state.er.date_start);
            this.setState({ startdate: moment(x) })
        }
        else {
            this.setState({ startdate: '' })
        }
        document.getElementById('date_start_input').classList.remove("hidden");
        document.getElementById('date_start_text').classList.add("hidden");
    }

    onEndDateTextClick() {
        if (this.state.er.date_end) {
            let x = Date.parse(this.state.er.date_end);
            this.setState({ enddate: moment(x) })
        }
        else {
            this.setState({ enddate: '' })
        }
        document.getElementById('date_end_input').classList.remove("hidden");
        document.getElementById('date_end_text').classList.add("hidden");
    }

    onGoLiveDateTextClick() {
        if (this.state.er.date_go_live) {
            let x = Date.parse(this.state.er.date_go_live);
            this.setState({ golivedate: moment(x) })
        }
        else {
            this.setState({ golivedate: '' })
        }
        document.getElementById('date_golive_input').classList.remove("hidden");
        document.getElementById('date_golive_text').classList.add("hidden");
    }

    onStartCloseClick() {
        document.getElementById('date_start_input').classList.add("hidden");
        document.getElementById('date_start_text').classList.remove("hidden");
    }

    onEndCloseClick() {
        document.getElementById('date_end_input').classList.add("hidden");
        document.getElementById('date_end_text').classList.remove("hidden");
    }

    onGoLiveCloseClick() {
        document.getElementById('date_golive_input').classList.add("hidden");
        document.getElementById('date_golive_text').classList.remove("hidden");
    }

    onStartSaveClick() {
        const fd = new FormData;
        fd.append('start_date', document.getElementById('start_date').value);
        fetch(this.state.apiUrl + '/ErRest/SaveStartDate/id/' + this.props.match.params.erId + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                if (findresponse.code == 200) {
                    this.setState({ message: findresponse.msg }, function () {
                        this.getErDetails();
                    });
                }
                document.getElementById('date_start_input').classList.add("hidden");
                document.getElementById('date_start_text').classList.remove("hidden");
            })
    }

    onEndSaveClick() {
        const fd = new FormData;
        fd.append('end_date', document.getElementById('end_date').value);
        fetch(this.state.apiUrl + '/ErRest/SaveEndDate/id/' + this.props.match.params.erId + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                if (findresponse.code == 200) {
                    this.setState({ message: findresponse.msg }, function () {
                        this.getErDetails();
                    });
                }
                document.getElementById('date_end_input').classList.add("hidden");
                document.getElementById('date_end_text').classList.remove("hidden");
            })
    }

    onGoLiveSaveClick() {
        const fd = new FormData;
        fd.append('go_live_date', document.getElementById('go_live_date').value);
        fetch(this.state.apiUrl + '/ErRest/SaveGoLiveDate/id/' + this.props.match.params.erId + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                if (findresponse.code == 200) {
                    this.setState({ message: findresponse.msg }, function () {
                        this.getErDetails();
                    });
                }
                document.getElementById('date_golive_input').classList.add("hidden");
                document.getElementById('date_golive_text').classList.remove("hidden");
            })
    }

    render() {
        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />
            )
        }
        return (
            <div>
                <Header brecum_name="Er's" brecum_page="Request Detail" NoteEdit={this.state.NoteEdit} />
                <div class="right_col">
                    {/* <--Remove Flag modal start-!> */}
                    <div class="modal fade" id="is_flag_remove" role="dialog">
                        <div class="modal-dialog modal-md">
                            <div class="modal-content">
                                <div class="modal-body">
                                    <div class="form-group">
                                        <h4 class="modal-title">{'Remove ' + this.props.match.params.erId + ' From Backlog ?'}</h4>
                                    </div>
                                </div>
                                <div class="modal-footer btn-muvi">
                                    <button type="button" class="btn btn-blue" id="flag_false_button" data-dismiss="modal">Cancel</button>
                                    <button type="button" class="btn btn-sky" onClick={this.state.er.is_flag == 1 ? () => this.removeFlag(this.props.match.params.erId) : ''} >Remove</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <--Remove Flag modal end-!> */}
                    {/* <--Is Flag True modal start-!> */}
                    <div class="modal fade" id="is_flag_true" role="dialog">
                        <div class="modal-dialog modal-md">
                            <div class="modal-content">
                                <div class="modal-body">
                                    <div class="form-group">
                                        <h4 class="modal-title">{'Add ' + this.props.match.params.erId + ' To Backlog ?'}</h4>
                                    </div>
                                </div>
                                <div class="modal-footer btn-muvi">
                                    <button type="button" class="btn btn-blue" id="flag_true_button" data-dismiss="modal">Cancel</button>
                                    <button type="button" class="btn btn-sky" onClick={this.state.er.is_flag == 0 ? () => this.addFlag(this.props.match.params.erId) : ''} >Add</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <--Is Flag True modal end-!> */}
                    {/* <--Is Flag False modal start-!> */}
                    <div class="modal fade" id="is_flag_false" role="dialog">
                        <div class="modal-dialog modal-md">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                                    <h4 class="modal-title">Invalid Status</h4>
                                </div>
                                <div class="modal-body">
                                    <div class="form-group">
                                        <h4>Please select status as <b>Assigned</b>.</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <--Is Flag False modal end-!> */}
                    {/* <--story move modal start-!> */}
                    <div class="modal fade" id="MoveStoryModal" role="dialog">
                        <div class="modal-dialog modal-md">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                                    <h4 class="modal-title">Do you want to move the story ?</h4>
                                </div>
                                <div class="modal-body">
                                    <div class="form-group">
                                        <label>Feature ID</label>
                                        <div class="react_auto">
                                            <MuiThemeProvider muiTheme={getMuiTheme()}>
                                                <AutoComplete
                                                    floatingLabelText="Search ticket number"
                                                    onUpdateInput={this.handleFeatureUpdateInput}
                                                    onNewRequest={this.handleFeatureNewRequest}
                                                    fullWidth={true}
                                                    placeholder='Search ER ID or Title'
                                                    filter={AutoComplete.caseInsensitiveFilter}
                                                    dataSource={this.state.feature_search}
                                                    dataSourceConfig={dataSourceConfig}
                                                    errorText={this.state.errorText}
                                                    maxSearchResults={8}
                                                    onKeyPress={this.enterKeyPress}
                                                    errorStyle={{ bottom: 0 }}
                                                    className="ticket_search_box"
                                                />
                                            </MuiThemeProvider>
                                        </div>
                                        <span class="error">{this.state.move_story_error_message}</span>
                                    </div>
                                </div>
                                <div class="modal-footer btn-muvi">
                                    <button type="button" class="btn btn-blue" data-dismiss="modal">Cancel</button>
                                    <button type="button" class="btn btn-sky" id="move_story_button" onClick={() => this.moveStoryToFeature()}>Move</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <--story move modal end-!> */}
                    {/* <--story link modal start-!> */}
                    <div class="modal fade" id="storyLinkModal" role="dialog">
                        <div class="modal-dialog modal-md">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                                    <h4 class="modal-title">Insert Link</h4>
                                </div>
                                <div class="modal-body">
                                    Text
                                    <br></br>
                                    <input type="text" name="story_text" id="story_text" class="form-control" onChange={this.onStoryLinkChange} />
                                    <br></br>
                                    Link
                                    <br></br>
                                    <input type="text" class="form-control" name="story_link" id="story_link" onChange={this.onStoryLinkChange} />
                                </div>
                                <div class="modal-footer btn-muvi">
                                    <button type="button" class="btn btn-blue" data-dismiss="modal">Close</button>
                                    <button type="button" class="btn btn-sky" id="insert_story_link" disabled data-dismiss="modal">OK</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <--story link modal start-!> */}
                    {/* <--release note modal start-!> */}
                    <div class="modal fade" id="releaseNoteModal" role="dialog">
                        <div class="modal-dialog modal-md">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                                    <h4 class="modal-title">Release Notes</h4>
                                </div>
                                <div class="modal-body">
                                    Add Release Note
                                    <br></br>
                                    <textarea type="text" name="release_note" class="form-control" onChange={this.onChange1}></textarea>
                                    <span class="error">{this.state.releaseNoteErrorMessage}</span>
                                    <br></br><br></br>
                                    Help Article
                                    <br></br>
                                    <input type="text" class="form-control" name="help_article" onChange={this.onChange1} />
                                </div>

                                <div class="modal-footer btn-muvi">
                                    <button type="button" class="btn btn-sky" id="insert_release_note" onClick={() => this.insertReleaseNote()}>Add</button>
                                    <button type="button" class="btn btn-blue" data-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <--release note modal start-!> */}
                    {/* <--release note detail modal start-!> */}
                    <div class="modal fade" id="releaseNoteDetailModal" role="dialog">
                        <div class="modal-dialog modal-md">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                                    <h4 class="modal-title">Release Notes</h4>
                                </div>
                                <div class="modal-body">
                                    {/* Release Note */}
                                    {/* <div class="details_title">Descriptions:</div> */}
                                    <div class="details_des" dangerouslySetInnerHTML={{ __html: this.state.release_notes ? this.state.release_notes.release_description : '' }} />

                                    <br></br>
                                    {this.state.release_notes ? (this.state.release_notes.release_link ?
                                        <span>
                                            <h4>Help Article</h4>
                                            <div class="details_des">{this.state.release_notes.release_link}</div></span> : '') : ''}
                                </div>
                                <div class="modal-footer btn-muvi">
                                    <button type="button" class="btn btn-blue" data-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <--release note detail modal start-!> */}
                    <div class="ticket_list">
                        <div class="loader-new"></div>
                        <div className="intranet_body hidden">
                            <div class="title mob er_ids"><div class="er_id"><span class="er">ID : </span><HeaderMob page_name={this.state.er.id + ' ' + (this.state.er.category == 64 ? '(' + this.state.config.category[this.state.er.category] + ')' : " ")} /></div>
                                <div class="edit pull-right hidden-md">
                                    <Link to={`/EditEr/${this.state.er.id}`} name={"max"}><i class="fa fa-pencil-square-o"></i></Link>
                                </div>
                                <div class="mob hidden-xs pull-right">
                                    Recently Visited :
                                    {this.state.recentlyview ?
                                        this.state.recentlyview.map((recentid, key) =>
                                            <span>
                                                {recentid != this.props.match.params.erId ?
                                                    <a href={'/viewEr/' + recentid} >&nbsp;{recentid} {this.state.recentlyview.length != (key + 1) ? '|' : ''}</a>
                                                    : ""}
                                            </span>
                                        )
                                        : ''}
                                </div>
                                <div class="react_auto">
                                    <MuiThemeProvider muiTheme={getMuiTheme()}>
                                        <AutoComplete
                                            floatingLabelText="Search ticket number"
                                            onUpdateInput={this.handleUpdateInput}
                                            onNewRequest={this.handleNewRequest}
                                            fullWidth={true}
                                            placeholder='Search ER ID or Title'
                                            filter={AutoComplete.caseInsensitiveFilter}
                                            dataSource={this.state.search}
                                            dataSourceConfig={dataSourceConfig}
                                            errorText={this.state.errorText}
                                            maxSearchResults={8}
                                            onKeyPress={this.enterKeyPress}
                                            errorStyle={{ bottom: 0 }}
                                            className="ticket_search_box"
                                        />
                                    </MuiThemeProvider>
                                    <i class="fa fa-search"></i>
                                </div>
                            </div>
                            <div class="top-row hidden-xs er_top">
                                <div class="left-section btn-muvi pull-left">
                                    {this.state.er.status != 90 ? ((this.state.er.category == 10 || this.state.er.category == 12) && this.state.linked_er.length > 0 ?
                                        (<Link to={`/EditFeatureCategoryEr/${this.state.er.id}`} name={"max"} className="btn btn-sky">Edit</Link>)
                                        : (<Link to={`/EditEr/${this.state.er.id}`} name={"max"} className="btn btn-sky">Edit</Link>)) : ''}
                                    <button type="button" className="btn btn-blue hidden-sm" onClick={() => this.goBack()} >Back</button>
                                </div>
                                <div class="right-section btn-muvi">
                                    <div class="searchTicket er_dpt">
                                        <div class="filter">
                                            <select id="owner" class="form-control" name="assigned_to" value={this.state.assigned_to} onChange={this.onChange.bind(this, 'assigned_to')}>
                                                <option value={this.state.userId}>[Myself] </option>
                                                {
                                                    this.state.owners.map((dynamicData, key) =>
                                                        <option value={dynamicData.id}>{dynamicData.name}</option>
                                                    )
                                                }
                                            </select>
                                            <i class="fal fa-angle-down" aria-hidden="true"></i>
                                        </div>
                                        <button type="submit" className="btn btn-blue" onClick={() => this.ChangeAllOwners()} >Assign To</button>
                                    </div>
                                    <div class="searchTicket er_dpt">
                                        <div class="filter">
                                            <select class="form-control" name="status_name" id="status" value={this.state.status_name} onChange={this.onChange.bind(this, 'status')} >
                                                {
                                                    this.state.workflow.map((dynamicData, index) =>
                                                        <option value={dynamicData.key}>{dynamicData.value}</option>
                                                    )
                                                }
                                            </select>
                                            <i class="fal fa-angle-down" aria-hidden="true"></i>
                                        </div>
                                        <button type="submit" className="btn btn-blue" onClick={() => this.ChangeAllStatus()}>Change Status</button>
                                    </div>
                                    <Link to={`/cloneEr/${this.state.er.id}`} name={"max"}><button className="btn btn-sky">Clone</button></Link>
                                    {this.state.status_name == 21 ? <button id="resume_button" className="btn btn-green" onClick={() => this.ResumeEr()} >Resume</button>: (this.state.status_name != 90 ?<button className="btn btn-blue" data-toggle="modal" data-target="#ChangeErToPaused">Pause</button>:'')}
                                    <button className="btn btn-blue btn-close" onClick={() => this.close_er()}>Close</button>
                                    {this.state.er.status == 84 || this.state.er.status == 90 ? (this.state.is_release_notes == 0 ? <a href="#" class="btn btn-sky tooltips" data-toggle="modal" data-target="#releaseNoteModal">Release Note</a> : <a href="#" class="btn btn-sky tooltips" data-toggle="modal" data-target="#releaseNoteDetailModal">Release Note</a>) : ''}
                                </div>
                            </div>
                            <div class="request_details er row">
                                <div class="col-md-9 col-xs-12">
                                    <div class="form-section">
                                        <div class="er_title hidden-sm">Request Details</div>
                                        {(this.state.er.category == 10 || this.state.er.category == 12) && this.state.linked_er.length > 0 ?
                                            <div class="details">
                                                <div class="">{this.state.config.category[this.state.er.category]} of Initiative <a target='_blank' href={'/viewEr/' + this.state.linked_er[0].id}>{this.state.linked_er[0].id}</a></div>
                                            </div>
                                            : ''}

                                        <div class="details">
                                            <div class="details_title">Title </div>
                                            <div class="details_des" dangerouslySetInnerHTML={{ __html: this.state.er.title }} />
                                        </div>
                                        <div class="details">
                                            <div class="details_title">Descriptions </div>
                                            <div class="details_des" dangerouslySetInnerHTML={{ __html: this.state.er.description }} />
                                        </div>
                                        <div class="details er-oneline">
                                            <div class="details_title"><span class="bold">Status </span></div>
                                            <div class="details_des"><div class={'er_status ' + this.getStatusClass(this.state.er.status)}>{this.state.er.status ? this.state.config.status[this.state.er.status] : "--"}</div></div>
                                        </div>
                                    </div>
                                    <div class="more_er">
                                        <a id="showmore" data-toggle="collapse" data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample" onClick={this.onToggle.bind()} href="javascript:void(0)">More Details </a>
                                    </div>
                                    {/* side modal for feature,task start */}
                                    <div id="mySidenav" class="sidenav er-right">
                                        <a href="javascript:void(0)" class="close_btn" onClick={() => this.closeNav()}><i class="fas fa-times"></i></a>
                                        <div class="form-section">
                                            <div class="details scrum-id">
                                                <div class="details_title">ID </div>
                                                <div class="details_des">{this.state.er_initiative.id}<span class="copystory_link tooltips"><i onClick={() => this.copylink(this.state.er_initiative.id)} class="fal fa-copy"></i><div class="tooltiptext copy_tooltip">{'copy'}</div></span></div>
                                            </div>
                                            <div class="middle">
                                                <div class="details_title">Title :</div>
                                                <div class="details"><b dangerouslySetInnerHTML={{ __html: this.state.er_initiative.title }}></b></div>
                                            </div>
                                            {this.state.er_initiative.description ? <div class="middle">
                                                <div class="details_title">Description :</div>
                                                <div class="details" dangerouslySetInnerHTML={{ __html: this.state.er_initiative.description }} />
                                            </div> : ''}
                                            <div class="bottom">
                                                <div class="details">
                                                    <div class="ticket_label">Status</div>
                                                    <div class="ticket_content"><div class={'er_status ' + this.getStatusClass(this.state.er_initiative.status)}>{this.state.er_initiative.status ? this.state.config.status[this.state.er_initiative.status] : "--"}</div></div>
                                                </div>
                                                <div class="details">
                                                    <div class="ticket_label">Priority</div>
                                                    <div class="ticket_content">{this.state.er_initiative.priority ? this.state.config.priority[this.state.er_initiative.priority] : "--"}</div>
                                                </div>
                                                <div class="details">
                                                    <div class="ticket_label">Assigned To</div>
                                                    <div class="ticket_content">{this.getAssignedToForInitiative()}</div>
                                                </div>
                                            </div>
                                            {this.state.story_for_feature.length > 0 ?
                                                <div class="middle">
                                                    <div class="details_title">Stories</div>
                                                    <div class="tickets hidden-sm">
                                                        <ul class="tickets_head er_head">
                                                            <li class="intra_col_20 text-center ed_id">ID</li>
                                                            <li class="intra_col_80">Story</li>
                                                        </ul>
                                                        <div class="story_list">
                                                            {this.state.story_for_feature.map((story_for_feature, key) =>
                                                                <ul class="related_er tickets_number">
                                                                    <li class="intra_col_20 text-center ed_id"><span class={this.getStatusClorClass(story_for_feature.status)}></span> <span>{story_for_feature.id}</span> </li>
                                                                    <li class="intra_col_80 text-inded">{story_for_feature.title}</li>
                                                                </ul>
                                                            )
                                                            }
                                                        </div>
                                                    </div>
                                                </div> : ''}
                                            <div class="details">
                                                <a className="btn btn-sky more" href={`/viewEr/${this.state.er_initiative.id}`}>More Details</a>
                                            </div>
                                        </div>
                                    </div>
                                    {/* side modal for feature,task end */}
                                    {/* side modal for story start */}
                                    <div id="storySidenav" class="sidenav er-right">
                                        <a href="javascript:void(0)" class="close_btn" onClick={() => this.closeStoryNav()}><i class="fas fa-times"></i></a>
                                        <div class="form-section">
                                            <div class="details scrum-id">
                                                <div class="details_title">ID </div>
                                                <div class="details_des">{this.props.match.params.erId + '_' + this.state.side_story_sequence_no}<span class="copystory_link tooltips"><i onClick={() => this.copystorylink(this.state.side_story_details.id, this.state.side_story_sequence_no)} class="fal fa-copy"></i><div class="tooltiptext copy_tooltip">{'copy'}</div></span></div>
                                            </div>
                                            <div class="middle">
                                                <div class="details_title">Story :</div>
                                                <div class="details"><b dangerouslySetInnerHTML={{ __html: this.state.side_story_details.title }}></b></div>
                                            </div>
                                            {this.state.side_story_details.description ? <div class="middle">
                                                <div class="details_title">Description :</div>
                                                <div class="details more_details" dangerouslySetInnerHTML={{ __html: this.state.side_story_details.description }} />
                                            </div> : ''}
                                            <div class="bottom">
                                                <div class="details">
                                                    <div class="ticket_label">Status </div>
                                                    <div class="ticket_content"><div class={'er_status ' + this.getStatusClass(this.state.side_story_details.status)}>{this.state.side_story_details.status ? this.state.config.story_status[this.state.side_story_details.status] : "--"}</div></div>
                                                </div>
                                                {this.state.side_story_details.acceptance_criteria ? <div class="details">
                                                    <div class="ticket_label">Acceptance Criteria </div>
                                                    <div class="ticket_content more_details" dangerouslySetInnerHTML={{ __html: this.state.side_story_details.acceptance_criteria }} />
                                                </div> : ''}
                                                <div class="details">
                                                    {this.state.side_story_attachments.length > 0 ? <div class="ticket_label">Mock Up</div> : ''}
                                                    <div class="ticket_content">
                                                        <div class="er_thumnail">
                                                            {
                                                                this.state.side_story_attachments.length > 0 ? this.state.side_story_attachments.map((attachment_name, key) =>
                                                                    <div class="mockup_thumnail">
                                                                        <span class="block"></span>
                                                                        <img src={attachment_name.url} />
                                                                        <div class="mockup_download">
                                                                            <span onClick={() => this.showImage(attachment_name.url, attachment_name.attachment_name)}><i class="fas fa-eye"></i></span>
                                                                            <span onClick={() => this.downloadImage(attachment_name.id)}><i class="fas fa-download"></i></span>
                                                                        </div>
                                                                        <span class="er_close" onClick={() => this.delteStoryimage(attachment_name.id, attachment_name.entity_id, attachment_name.attachment_name)}><i class="fas fa-times"></i></span>
                                                                    </div>
                                                                ) : ''
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="details">
                                                <a className="btn btn-sky more" href={`/viewStory/${this.state.side_story_details.id}/sequence/${this.state.side_story_sequence_no}`}>More Details</a>
                                            </div>
                                        </div>
                                    </div>
                                    {/* side modal for story end */}
                                    <div class="form-section collapse" id="collapseExample">
                                        <div class="row">
                                            <div class="col-md-4 col-xs-12 ticket-1st">
                                                <div class="details row">
                                                    <div class="col-md-6 col-xs-6 ticket_label"><span class="bold">Project </span></div>
                                                    <div class="col-md-6 col-xs-6 ticket_content">Muvi</div>
                                                </div>
                                                <div class="details row">
                                                    <div class="col-md-6 col-xs-6 ticket_label"><span class="bold">Category </span></div>
                                                    <div class="col-md-6 col-xs-6 ticket_content owner">{this.state.er.category ? this.state.config.category[this.state.er.category] : "--"}</div>
                                                </div>
                                                <div class="details row">
                                                    <div class="col-md-6 col-xs-6 ticket_label"><span class="bold">POD/Department </span></div>
                                                    <div class="col-md-6 col-xs-6 ticket_content owner">{this.state.er.product_line ? this.state.config.pod[this.state.er.product_line] : "--"}</div>
                                                </div>
                                                <div class="details row">
                                                    <div class="col-md-6 col-xs-6 ticket_label"><span class="bold">Priority </span></div>
                                                    <div class="col-md-6 col-xs-6 ticket_content">{this.state.er.priority ? this.state.config.priority[this.state.er.priority] : "--"}</div>
                                                </div>
                                            </div>
                                            <div class="col-md-4 col-xs-12 ticket-2nd hide_mob">
                                                <div class="details row">
                                                    <div class="col-md-6 col-xs-6 ticket_label"><span class="bold">Type </span></div>
                                                    <div class="col-md-6 col-xs-6 ticket_content owner">{this.state.er.type ? this.state.config.type[this.state.er.type] : "--"}</div>
                                                </div>
                                                <div class="details row">
                                                    <div class="col-md-6 col-xs-6 ticket_label"><span class="bold">Ticket </span></div>
                                                    <div class="col-md-6 col-xs-6 ticket_content">
                                                        <ul className="mantis">
                                                            {this.state.multi_ticket.map((multiTicket, index) =>
                                                                <li key={multiTicket.key}>
                                                                    <a onClick={() => this.showhelpdeskid(multiTicket.value)}>
                                                                        {multiTicket.value}
                                                                    </a>
                                                                </li>
                                                            )}
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div class="details row">
                                                    <div class="col-md-6 col-xs-6 ticket_label"><span class="bold">Server </span></div>
                                                    <div class="col-md-6 col-xs-6 ticket_content">{this.state.er.server ? this.state.config.server[this.state.er.server] : '--'}</div>
                                                </div>
                                                <div class="details row">
                                                    <div class="col-md-6 col-xs-6 ticket_label"><span class="bold">Effort </span></div>
                                                    <div class="col-md-6 col-xs-6 ticket_content">{this.state.er.effort ? this.state.config.effort[this.state.er.effort] : '--'}</div>
                                                </div>
                                                {this.state.er.category == 12 ? <div class="details row">
                                                    <div class="col-md-6 col-xs-6 ticket_label"><span class="bold">Feature Type </span></div>
                                                    <div class="col-md-6 col-xs-6 ticket_content">{this.state.er.feature_type == 1 ? 'Major Feature' : (this.state.er.feature_type == 2 ? 'Native(Mobile/TV)' : (this.state.er.feature_type == 3 ? 'Platform' : ''))}</div>
                                                </div> : ''}
                                            </div>
                                            <div class="col-md-4 col-xs-12 ticket-3rd hide_mob">
                                                <div class="details row">
                                                    <div class="col-md-6 col-xs-6 ticket_label"><span class="bold">Escalation Level </span></div>
                                                    <div class="col-md-6 col-xs-6 ticket_content">{this.state.er.support_level}</div>
                                                </div>
                                                <div class="details row">
                                                    <div class="col-md-6 col-xs-6 ticket_label"><span class="bold">OS Version </span></div>
                                                    <div class="col-md-6 col-xs-6 ticket_content owner">{this.state.er.os_version ? this.state.config.os_version[this.state.er.os_version] : '--'}</div>
                                                </div>
                                                <div class="details row">
                                                    <div class="col-md-6 col-xs-6 ticket_label"><span class="bold">Browser </span></div>
                                                    <div class="col-md-6 col-xs-6 ticket_content">{this.state.er.browser ? this.state.config.browser[this.state.er.browser] : '--'}</div>
                                                </div>
                                                <div class="details row">
                                                    <div class="col-md-6 col-xs-6 ticket_label"><span class="bold">Browser Version </span></div>
                                                    <div class="col-md-6 col-xs-6 ticket_content">{this.state.er.browser_version}</div>
                                                </div>
                                                {/* <div class="details row">
                                                    <div class="col-md-7 col-xs-6 ticket_label"><span class="bold">Microservice </span></div>
                                                    <div class="col-md-5 col-xs-6 ticket_content">{this.state.er.microservice ? this.state.config.microservice[this.state.er.microservice] : "--"}</div>
                                            </div> */}
                                            </div>
                                            <div class="show-more hidden-md"><i class="fa fa-angle-double-down"></i><span>Show More</span></div>
                                        </div>
                                    </div>
                                    <div class="request_details">
                                        {this.state.er.category == 10 || this.state.er.category == 13 ? <div class="er_title">Related ER</div> : <div id="exTab1" class="container title">
                                            <ul class="nav nav-pills">
                                                {this.state.er.category == 64 ? <li class="active"><a href="#more_er" data-toggle="tab">ER</a></li> : ''}
                                                {this.state.er.category == 12 || this.state.er.category == 136 ? <li class="active"><a href="#stories" data-toggle="tab">Stories</a></li> : ''}
                                                {this.state.er.category == 77 ? <li class="active"><a href="#ideas" data-toggle="tab">Ideas</a></li> : ''}
                                                <li><a href="#related_er" data-toggle="tab">Related ER</a></li>
                                            </ul>
                                        </div>}
                                        <div class="tab-content customer-tab clearfix">
                                            {this.state.er.category == 64 ?
                                                <div className="tab-pane active" id="more_er">
                                                    <div class="top-row m_t_20">
                                                        <div class="left-section btn-muvi pull-left">
                                                            {this.state.er.category == 64 ? <Link to={`/addEr/${this.state.er.id}`} class="btn btn-sky mob">
                                                                <span class="hidden-sm">Add ER</span>
                                                                <span class="mob_icon_plus hidden-md">
                                                                    <i class="fal fa-plus"></i>
                                                                </span>
                                                            </Link> : ''}
                                                        </div>
                                                        <div class="right-section">
                                                            <div class="row er_box">
                                                                <div class="col-md-4 col-xs-12">
                                                                    <div class="filter">
                                                                        <select class="form-control" name="search_er_category" onChange={this.searchChange}>
                                                                            <option value='' selected="selected">Category</option>
                                                                            {
                                                                                this.state.bug_feature_category_workflow.map((user, key) =>
                                                                                    <option value={user.key}>{user.value}</option>
                                                                                )}
                                                                        </select>
                                                                        <i class="fa fa-angle-down" aria-hidden="true"></i>
                                                                    </div>
                                                                </div>
                                                                <div class="col-md-8 col-xs-12">
                                                                    <div class="searchTicket emp_dept wid_100">
                                                                        <input type="text" class="form-control" placeholder="Search" name='search_er' onChange={this.searchChange} />
                                                                        <button type="submit"><i class="fa fa-search"></i></button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="list_check hidden-sm">
                                                        <div class="tickets ">
                                                            {this.state.linked_er.length > 0 ? <ul class="tickets_head er_head">
                                                                <li class="intra_col_10 text-center" id="col_id" >ID</li>
                                                                <li class="intra_col_42" id="col_title">Title</li>
                                                                <li class="intra_col_12" id="col_priority" >Category</li>
                                                                <li class="intra_col_18" id="col_priority" >POD</li>
                                                                <li class="intra_col_10" id="col_category" >Status</li>
                                                                <li class="intra_col_8" id="col_product_line" >Action</li>
                                                            </ul> : ''}

                                                            {
                                                                this.state.linked_er.map((related_er, key) =>
                                                                    <ul class="related_er tickets_number">
                                                                        <li class="intra_col_10 text-center ed_id">
                                                                            <span class={this.getStatusClorClass(related_er.status)}></span>
                                                                            <span onClick={() => this.openNav(related_er.id)}><a href="javascript:void(0)">{related_er.id}</a></span>
                                                                        </li>
                                                                        <li class="intra_col_42 text-inded" dangerouslySetInnerHTML={{ __html: related_er.title }}></li>
                                                                        <li class="intra_col_12">{this.state.related_category[related_er.category]}</li>
                                                                        <li class="intra_col_18" id="col_priority" >{related_er.product_line ? this.state.config.pod[related_er.product_line] : '--'}</li>
                                                                        <li class="intra_col_10 color-sky">{this.state.related_status[related_er.status]}</li>
                                                                        <li class="intra_col_8">{this.getUsersMenu(related_er.id, this.state.er.id)}
                                                                        </li>
                                                                    </ul>
                                                                )
                                                            }
                                                        </div>
                                                    </div>
                                                    <div class="tickets_mob er_list hidden-md">
                                                        {
                                                            this.state.linked_er.map((er, key) =>
                                                                <Link key={key} to={`/viewEr/${er.id}`} name={"max"}>
                                                                    <div class="list_mob">
                                                                        <span onClick={() => this.goToErDetails(er.id, er.assigned_to, er.owner)}>
                                                                            <h4 class="list_title">
                                                                                <div class="er_color">
                                                                                    <span class={this.getStatusClorClass(er.status)}></span>
                                                                                    <div class="text-inded">{er.title}</div>
                                                                                </div>
                                                                            </h4>
                                                                            <div class="section">
                                                                                <div class="wrap pull-left">
                                                                                    <label>#Ticket:</label><span>{er.id}</span>
                                                                                </div>
                                                                                <div class="wrap pull-right">
                                                                                    <label>Priority</label><div class="text-capitalize">{er.priority ? this.state.config.priority[er.priority] : ''}</div>
                                                                                </div>
                                                                            </div>
                                                                            <div class="section gry">
                                                                                <div class="wrap">
                                                                                    <label>POD</label><span>{er.product_line ? this.state.config.pod[er.product_line] : ''}</span>
                                                                                </div>
                                                                                <div class="wrap pull-right">
                                                                                    <label>Status</label><span>{er.status ? this.state.config.status[er.status] : "--"}</span>
                                                                                </div>
                                                                            </div>
                                                                        </span>
                                                                    </div>
                                                                </Link>
                                                            )
                                                        }
                                                    </div>
                                                </div> : ''}
                                            {this.state.er.category == 12 || this.state.er.category == 136 ?
                                                <div className="tab-pane active" id="stories">
                                                    <div class="er-story m_t_10">
                                                        <div class="left_ers">
                                                            <div class="form-group">
                                                                <input type="text" name="input_story" id="input_story" placeholder="Add your story here" class="form-control" onChange={this.onChange1} />
                                                                <span class="error">{this.state.story_title_error_message}</span>
                                                            </div>
                                                            <textarea class="form-control m_t_10" name="input_story_desc" id="input_story_desc" placeholder="Story Description" onChange={this.onChange1}></textarea>
                                                        </div>
                                                        <div class="right_ers">
                                                            <div class="er_story_box">
                                                                <span class="upload_btn mob">
                                                                    <input type="file" name="story_attachment" id="story_attachment" class="inputfile inputfile-1" data-multiple-caption="{count} files selected" multiple />
                                                                    <label for="story_attachment">
                                                                        <span class="hidden-md">Upload</span>
                                                                        <i class="fal fa-paperclip hidden-sm"></i>
                                                                    </label>
                                                                </span>
                                                            </div>
                                                            <div class="er_story_box">
                                                                <button data-toggle="modal" data-target="#storyLinkModal" class="link">
                                                                    <span class="hidden-md">Link</span>
                                                                    <i class="fas fa-link hidden-sm"></i>
                                                                </button>
                                                            </div>
                                                            <div class="er_story_box add story">
                                                                <button type="submit" name="input_story_button" id="input_story_button" class="btn btn-blue mob-btn" onClick={() => this.insertStory()} >Add</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="clearfix"></div>
                                                    <div class="m_t_20">
                                                        <a id="showmorestory" data-toggle="collapse" data-target="#collapseStoryExample" aria-expanded="false" aria-controls="collapseStoryExample" onClick={this.onToggleStory.bind()} href="javascript:void(0)">View More <i class="fa fa-angle-down" aria-hidden="true"></i></a>
                                                    </div>
                                                    <div class="form-section collapse" id="collapseStoryExample">
                                                        <div class="btn-muvi margin_top_less">
                                                            <div class="searchTicket er_dpt">
                                                                <div class="filter">
                                                                    <select id="story_owner" class="form-control" name="story_owner" onChange={this.onChange1}>
                                                                        <option value={this.state.userId}>[Myself] </option>
                                                                        {
                                                                            this.state.owners.map((dynamicData, key) =>
                                                                                <option value={dynamicData.id}>{dynamicData.name}</option>
                                                                            )
                                                                        }
                                                                    </select>
                                                                    <i class="fal fa-angle-down" aria-hidden="true"></i>
                                                                </div>
                                                                <button type="button" id='story_assign_to_button' className="btn btn-blue" onClick={() => this.ChangeStoryOwners()} >Assign To</button>
                                                            </div>
                                                            {/* checked_story_error_message */}
                                                            <div class="searchTicket er_dpt">
                                                                <div class="filter">
                                                                    <select class="form-control" name="story_status_name" id="story_status_name" onChange={this.onChange1} >
                                                                        {
                                                                            this.state.story_status.map((dynamicData, index) =>
                                                                                <option value={dynamicData.key}>{dynamicData.value}</option>
                                                                            )
                                                                        }
                                                                    </select>
                                                                    <i class="fal fa-angle-down" aria-hidden="true"></i>
                                                                </div>
                                                                <button id='story_status_button' type="submit" className="btn btn-blue" onClick={() => this.ChangeStoryStatus()}>Change Status</button>
                                                            </div>
                                                            {this.state.checked_story_length != '' || this.state.checked_story_length != 0 ? <button className="btn btn-blue btn-close" data-toggle="modal" data-target="#MoveStoryModal">Move</button> : <button className="btn btn-blue btn-close" onClick={() => this.MoveStoryErrorMsg()} >Move</button>}
                                                        </div>
                                                        <span class="error">{this.state.checked_story_error_message}</span>
                                                    </div>
                                                    <div class="list_check story_er hidden-sm">
                                                        <div class="tickets ">
                                                            {this.state.story_er.length > 0 ? <ul class="tickets_head er_head">
                                                                <li class="intra_col_3"></li>
                                                                <li class="intra_col_12 text-center" id="col_id" >ID</li>
                                                                <li class="intra_col_63" id="col_title">Story</li>
                                                                <li class="intra_col_10" id="col_category">Status</li>
                                                                <li class="intra_col_8 text-center" id="col_product_line">Action</li>
                                                            </ul> : ''}

                                                            {
                                                                this.state.story_er.map((story_er, key) =>
                                                                    <ul class="related_er tickets_number">
                                                                        <li class="intra_col_3">
                                                                            <div class="feature-check">
                                                                                <input type='checkbox' class='story_id_checkbox' name='story_id_checkbox' id={'story_id_checkbox' + story_er.id} value={story_er.id + '_' + story_er.sequence_no} onChange={this.onChange1} />
                                                                                <label for={"story_id_checkbox" + story_er.id}><span></span></label>
                                                                            </div>
                                                                        </li>
                                                                        <li class="intra_col_12 text-center ed_id">
                                                                            <span class={this.getStatusClorClass(story_er.status)}></span>
                                                                            <span onClick={() => this.openStoryNav(story_er.id, story_er.sequence_no)}><a href="javascript:void(0)">{this.props.match.params.erId + '_' + story_er.sequence_no}</a></span>
                                                                        </li>
                                                                        <li class="intra_col_63 padding_right_15" >
                                                                            <div class="er_story_list_title" id={"er_story_list_title" + story_er.id} dangerouslySetInnerHTML={{ __html: story_er.title }} onClick={() => this.storyId(story_er.id)}></div>
                                                                            <div id={"story_list_text_" + story_er.id} className={"hidden story_list_text_" + story_er.id}>
                                                                                <textarea type="text" name={key} className="form-control" id={"story_title_text_" + story_er.id} value={story_er.story_title} onChange={this.onChangeStoryTitle.bind(this, 'story_title')}></textarea>
                                                                                <div class='pull-right m_t_10'>
                                                                                    <button type="button" class="btn btn-sky" onClick={() => this.onSubmitStoryTitleClick(story_er.id, story_er.sequence_no)} ><i class="fa fa-check" aria-hidden="true"></i></button>
                                                                                    <button type="button" class="btn btn-blue" onClick={() => this.onStoryTextClick(story_er.id)} ><i class="fa fa-times" aria-hidden="true"></i></button>
                                                                                </div>
                                                                            </div>
                                                                            {this.state.errors["storyTitle_error_" + story_er.id] ? <div class="form-group">
                                                                                <span class="error">{this.state.errors["storyTitle_error_" + story_er.id]}</span>
                                                                            </div> : ''}
                                                                            {
                                                                                story_er.attachment_name.length > 0 ? story_er.attachment_name.map((attachment_name, key) =>
                                                                                    <div class="attached mail" onClick={() => this.showImage(attachment_name.url, attachment_name.attachment_name)}  >
                                                                                        <i class="far fa-file"></i>{attachment_name.attachment_name}
                                                                                    </div>
                                                                                ) : ''
                                                                            }
                                                                            {story_er.story_link != '' && story_er.story_text != '' ? <div><a class="attached mail" href={story_er.story_link} target="_blank">{story_er.story_text}<i class="fas fa-link hidden-sm"></i></a></div> : ''}
                                                                        </li>
                                                                        <li class="intra_col_10">{this.state.config.story_status[story_er.status]}</li>
                                                                        <li class="intra_col_8 text-center">
                                                                            <div class="edit_delete">
                                                                                <span class="edit">
                                                                                    <Link class="" to={`/EditStory/${story_er.id}/sequence/${story_er.sequence_no}`} name={"max"}><i class="fa fa-pencil-square-o" aria-hidden="true"></i></Link>
                                                                                </span>
                                                                                <span class="delete">
                                                                                    <i onClick={() => this.RemoveStory(story_er.id)} class="fa fa-trash" aria-hidden="true"></i>
                                                                                </span>
                                                                            </div>
                                                                        </li>
                                                                    </ul>
                                                                )
                                                            }
                                                        </div>
                                                    </div>
                                                    <div class="tickets_mob er_list hidden-md">
                                                        {
                                                            this.state.story_er.map((er, key) =>
                                                                <div class="list_mob">
                                                                    <span >
                                                                        <h4 class="list_title">
                                                                            <div class="er_color">
                                                                                <span class={this.getStatusClorClass(er.status)}></span>
                                                                                <div class="text-inded" onClick={() => this.goToStoryDetails(er.id, er.assigned_to, er.owner, er.sequence_no)}>{er.title}</div>
                                                                            </div>
                                                                        </h4>
                                                                        <div class="section">
                                                                            <div class="wrap pull-left">
                                                                                <label>#Story Id:</label><span onClick={() => this.goToStoryDetails(er.id, er.assigned_to, er.owner, er.sequence_no)}>{er.id}</span>
                                                                            </div>
                                                                            <div class="wrap pull-right">
                                                                                <label>Status</label><div class="text-capitalize">{er.status ? this.state.config.status[er.status] : ''}</div>
                                                                            </div>
                                                                        </div>
                                                                        <div class="section gry">
                                                                            {
                                                                                er.attachment_name.length > 0 ? er.attachment_name.map((attachment_name, key) =>
                                                                                    <div class="attached mail" onClick={() => this.showImage(attachment_name.url, attachment_name.attachment_name)}  >
                                                                                        <i class="far fa-file"></i>{attachment_name.attachment_name}
                                                                                    </div>
                                                                                ) : ''
                                                                            }
                                                                            <div class="wrap pull-right">

                                                                                <span class="icon_delete"><i class="fa fa-trash" onClick={() => this.RemoveStory(er.id)}></i></span>
                                                                            </div>
                                                                        </div>

                                                                    </span>
                                                                </div>
                                                            )
                                                        }
                                                    </div>
                                                </div>
                                                : ''}
                                            {this.state.er.category == 77 ?
                                                <div className="tab-pane active" id="ideas">
                                                    <div class="top-row m_t_20 related_er_box">
                                                        <div class="left-section btn-muvi pull-left">
                                                            {this.state.er.category == 77 ?
                                                                <Link to={`/addEr/${this.state.er.id}`} class="btn btn-sky mob">
                                                                    <span class="hidden-sm">Add ER</span>
                                                                    <span class="mob_icon_plus hidden-md">
                                                                        <img src={Add_request} />
                                                                    </span>
                                                                </Link>
                                                                : ''}
                                                        </div>
                                                        <div class="right-section">
                                                            <div class="row er_box">
                                                                <div class="col-md-4 col-xs-12">
                                                                    <div class="filter">
                                                                        <select class="form-control" name="search_er_category" onChange={this.searchChange}>
                                                                            <option value='' selected="selected">Category</option>
                                                                            {
                                                                                this.state.category.map((user, key) =>
                                                                                    <option value={user.key}>{user.value}</option>
                                                                                )}
                                                                        </select>
                                                                        <i class="fa fa-angle-down" aria-hidden="true"></i>
                                                                    </div>
                                                                </div>
                                                                <div class="col-md-8 col-xs-12">
                                                                    <div class="searchTicket emp_dept">
                                                                        <input type="text" class="form-control" placeholder="Search" name='search_er' onChange={this.searchChange} />
                                                                        <button type="submit"><i class="fa fa-search"></i></button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="list_check hidden-sm">
                                                        <div class="tickets ">
                                                            {this.state.linked_er.length > 0 ? <ul class="tickets_head er_head">
                                                                <li class="intra_col_10 text-center" id="col_id" >ID</li>
                                                                <li class="intra_col_40" id="col_title">Title</li>
                                                                <li class="intra_col_10" id="col_priority">Category</li>
                                                                <li class="intra_col_10" id="col_priority">POD</li>
                                                                <li class="intra_col_15" id="col_category">Status</li>
                                                                <li class="intra_col_15" id="col_product_line">Action</li>
                                                            </ul> : ''}

                                                            {
                                                                this.state.linked_er.map((related_er, key) =>
                                                                    <ul class="related_er tickets_number">
                                                                        <li class="intra_col_10 text-center ed_id">
                                                                            <span class={this.getStatusClorClass(related_er.status)}></span>
                                                                            <span onClick={() => this.openNav(related_er.id)}><a href="javascript:void(0)">{related_er.id}</a></span>
                                                                        </li>
                                                                        <li class="intra_col_40">{related_er.title}</li>
                                                                        <li class="intra_col_10">{this.state.related_category[related_er.category]}</li>
                                                                        <li class="intra_col_10" id="col_priority" >{related_er.product_line ? this.state.config.pod[related_er.product_line] : '--'}</li>
                                                                        <li class="intra_col_15 color-sky">{this.state.related_status[related_er.status]}</li>
                                                                        <li class="intra_col_15">{this.getUsersMenu(related_er.id, this.state.er.id)}</li>
                                                                    </ul>
                                                                )
                                                            }
                                                        </div>
                                                    </div>
                                                    <div class="tickets_mob er_list hidden-md">
                                                        {
                                                            this.state.linked_er.map((er, key) =>
                                                                <div class="list_mob">
                                                                    <span>
                                                                        <h4 class="list_title">
                                                                            <div class="er_color">
                                                                                <span class={this.getStatusClorClass(er.status)}></span>
                                                                                <div class="text-inded" onClick={() => this.goToErDetails(er.id, er.assigned_to, er.owner)}>{er.title}</div>
                                                                            </div>
                                                                            <div class="edit-m">{this.getUsersMenu(er.id, this.state.er.id)}</div>
                                                                        </h4>
                                                                        <div class="section">
                                                                            <div class="wrap pull-left">
                                                                                <label>#Er Id:</label><span onClick={() => this.goToErDetails(er.id, er.assigned_to, er.owner)}>{er.id}</span>
                                                                            </div>
                                                                            <div class="wrap pull-right">
                                                                                <label>Status</label><div class="text-capitalize">{er.status ? this.state.config.status[er.status] : ''}</div>
                                                                            </div>
                                                                        </div>
                                                                        <div class="section gry">
                                                                            <div class="wrap pull-left">
                                                                                <label>Category:</label><span>{this.state.config.category[er.category]}</span>
                                                                            </div>
                                                                            <div class="wrap pull-right">
                                                                                <label>POD</label><span>{this.state.config.pod[er.product_line]}</span>
                                                                            </div>
                                                                        </div>
                                                                    </span>
                                                                </div>
                                                            )
                                                        }
                                                    </div>
                                                </div> : ''}
                                            <div class={this.showTab(this.state.er.category)} id="related_er">
                                                <div class="er_related">
                                                    <div class="intra_col_13"><span class="bold">Current issue</span></div>
                                                    <div className="intra_col_20">
                                                        <select class="form-control" name="related_to_er" id="related_to_er" onChange={this.onChange1} >
                                                            <option value='' selected="selected">related to</option>
                                                            {
                                                                this.state.related_to.map((dynamicData, index) =>
                                                                    <option value={dynamicData.key}>{dynamicData.value}</option>
                                                                )
                                                            }
                                                        </select>
                                                    </div>
                                                    <div class="intra_col_30 related_error">
                                                        <div class="searchTicket emp_dept">
                                                            <div class="react_auto">
                                                                <MuiThemeProvider muiTheme={getMuiTheme()}>
                                                                    <AutoComplete
                                                                        id="related_er_id"
                                                                        name="related_er_id"
                                                                        floatingLabelText="Search ticket number"
                                                                        onUpdateInput={this.handleRelationUpdateInput}
                                                                        onNewRequest={this.handleRelationNewRequest}
                                                                        fullWidth={true}
                                                                        placeholder='Search ER ID or Title'
                                                                        filter={AutoComplete.caseInsensitiveFilter}
                                                                        dataSource={this.state.relation_search}
                                                                        dataSourceConfig={dataRelationSourceConfig}
                                                                        maxSearchResults={8}
                                                                        onKeyPress={event => {
                                                                            if (event.key === 'Enter') {
                                                                                this.InsertRelatedToER()
                                                                            }
                                                                        }}
                                                                        errorStyle={{ bottom: 0 }}
                                                                        className="ticket_search_box"
                                                                    />
                                                                </MuiThemeProvider>
                                                                <i class="fa fa-search"></i>
                                                            </div>
                                                            <button type="submit" class="btn btn-blue" onClick={() => this.InsertRelatedToER()}>Add</button>
                                                        </div>
                                                        {this.state.errors["related_er"] ? <span class="error">{this.state.errors["related_er"]}</span> : ''}
                                                    </div>
                                                </div>
                                                <div class="list_check">
                                                    {this.state.related_er.length > 0 ?
                                                        <div class="tickets hidden-sm">
                                                            <ul class="tickets_head">
                                                                <li class="intra_col_10 text-center">ID</li>
                                                                <li class="intra_col_10">Priority</li>
                                                                <li class="intra_col_15">Category</li>
                                                                <li class="intra_col_10">Status</li>
                                                                <li class="intra_col_15">Updated</li>
                                                                <li class="intra_col_35">Title</li>
                                                                <li class="intra_col_5">Action</li>
                                                            </ul>
                                                            {
                                                                this.state.related_er.map((related_er, key) =>
                                                                    <ul class="related_er tickets_number">
                                                                        <li class="intra_col_10 text-center ed_id">
                                                                            <span class={this.getStatusClorClass(related_er.status)}></span>
                                                                            <a href={'/viewEr/' + related_er.id}>{related_er.id}</a>
                                                                        </li>
                                                                        <li class="intra_col_10">{this.state.related_priority[related_er.priority]}</li>
                                                                        <li class="intra_col_15">{this.state.related_category[related_er.category]}</li>
                                                                        <li class="intra_col_10 color-sky">{this.state.related_status[related_er.status]}</li>
                                                                        <li class="intra_col_15">{related_er.updated && related_er.updated != '30-11--0001' ? related_er.updated : ''}</li>
                                                                        <li class="intra_col_35 text-inded">{related_er.title}</li>
                                                                        <li class="intra_col_5 text-center"><span class="icon_delete"><i class="fa fa-trash" onClick={() => this.RemoveRelation(related_er.id, this.state.er.id)}></i></span></li>
                                                                    </ul>
                                                                )
                                                            }
                                                        </div>
                                                        : ''}
                                                </div>
                                            </div>
                                            <div id="exTab1" class="container title">
                                                <ul class="nav nav-pills">
                                                    <li class="active"><a href="#note" data-toggle="tab">Notes</a></li>
                                                    <li><a href="#history" data-toggle="tab">History</a></li>
                                                </ul>
                                            </div>
                                            <div class="tab-content customer-tab clearfix">
                                                <div className="tab-pane active" id="note">
                                                    <div class="row">
                                                        <div className="form-section ckeditor">
                                                            <CKEditor
                                                                activeClass="p10"
                                                                name='note'
                                                                content={this.state.note}
                                                                config={{
                                                                    extraAllowedContent : '*[*]{*}(*)'
                                                                }}
                                                                events={{
                                                                    "change": this.ckOnChange1
                                                                }}
                                                            />
                                                            <div id='note_autoseggestion'></div>
                                                            <span style={{ color: "red" }}>{this.state.errors["note"]}</span>
                                                        </div>
                                                        <div class="form-section ckeditor_upload">
                                                            <div class="upload">
                                                                <label>Add Attachment :</label>
                                                                <div class="upload_btn">
                                                                    <input type="file" name="attachments" id="attachments" class="inputfile inputfile-1" data-multiple-caption="{count} files selected" multiple />
                                                                    <label for="file-1">
                                                                        <i class="fa fa-plus hidden-sm" aria-hidden="true"></i>
                                                                        <span>Choose file</span>
                                                                        <i class="fa fa-cloud-upload-alt hidden-md" aria-hidden="true"></i>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="form-section ckeditor">
                                                            <button type="submit" name="add_note" id="add_note" className="btn btn-sky mob-btn" onClick={() => this.AddNote()}>Add Note</button>
                                                        </div>
                                                    </div>
                                                    <div className="feedback">
                                                        {this.state.notes.length > 0 ?
                                                            <h5 class="title"><span>View Note</span></h5>
                                                            : ''}
                                                        {
                                                            this.state.notes.map((data, key) =>
                                                                <div class="sub_feedback" id={'note' + data.id}>
                                                                    <div class="main">
                                                                        <div class="pro_image">
                                                                            <Link to={`/viewEmployee/${data.user_id}`} name={"max"} class="shw_ltr">
                                                                                {this.state.formatted_owners[data.user_id].attachment_url ? <img src={this.state.formatted_owners[data.user_id].attachment_url + this.state.formatted_owners[data.user_id].attachment} /> : <span class="profile_first_name">{this.state.formatted_owners[data.user_id].img_name}</span>}
                                                                            </Link>
                                                                        </div>
                                                                        <div class="fa-icon tooltips">
                                                                            {this.NoteEditCondition(data.id, data.note)}
                                                                        </div>
                                                                        <h6><Link to={`/viewEmployee/${data.user_id}`} name={"max"}>{data.owner_name}</Link></h6>
                                                                        <span class="date">{data.created_date}</span>
                                                                    </div>
                                                                    <div class="sub">
                                                                        <a href={'#note' + data.id} key={key} to={data.id} name={'note' + data.id}><span>Note {data.id}</span></a>
                                                                        <br />{data.note_history !=0? this.state.config.histroy[data.note_history]:''}{data.note_history !=0? ': ':''}
                                                                        <div class="note_list" dangerouslySetInnerHTML={{ __html: data.note }} />
                                                                    </div>
                                                                    {this.state.er_note_attachment[data.id] ?
                                                                        <div>
                                                                            {
                                                                                this.state.er_note_attachment[data.id].map((data, key) =>
                                                                                    <div class="attached" onClick={() => this.showImage(data.url, data.attachment_name)}  >
                                                                                        <i class="far fa-file"></i>{data.attachment_name}
                                                                                    </div>
                                                                                )
                                                                            }
                                                                        </div>
                                                                        : ''}
                                                                </div>
                                                            )
                                                        }
                                                    </div>
                                                </div>
                                                <div class="tickets tab-pane " id="history">
                                                    <div className="feedback">
                                                        {this.state.er_history.length > 0 ?
                                                            <h5 class="title"><span>ER History</span></h5>
                                                            : ''}
                                                        <ul class="tickets_head">
                                                            <li class="intra_col_25">Date</li>
                                                            <li class="intra_col_25">User</li>
                                                            <li class="intra_col_25">Field</li>
                                                            <li class="intra_col_25">Change</li>
                                                        </ul>
                                                        {
                                                            this.state.er_history.map((ErHistory, key) =>
                                                                <ul class="tickets_number">
                                                                    {ErHistory.type == 0 && ErHistory.field_name == 'feature_type' && ErHistory.new_value == 0 ? delete (ErHistory.id) :
                                                                        <div>
                                                                            <li class="intra_col_25">{ErHistory.created_date} </li>
                                                                            {ErHistory.user_id !== '0' ?

                                                                                <li class="intra_col_25">
                                                                                    <Link to={`/viewEmployee/${ErHistory.user_id}`} name={"max"}> {this.state.formatted_owners[ErHistory.user_id].name}</Link></li> : <li class="intra_col_25">NIL</li>}
                                                                            <li class="intra_col_25">
                                                                                {ErHistory.type == 22 ? 'ER Added' : ErHistory.type == 2 ? (ErHistory.old_value ? 'Note Added : ' + ErHistory.old_value : '') : (ErHistory.type == 3 ? 'Note Updated : ' + (ErHistory.old_value ? ErHistory.old_value : '') : (ErHistory.type == 6 ? 'Description Updated' : (ErHistory.type == 9 ? 'File Added : ' + (ErHistory.old_value ? ErHistory.old_value : '') : (ErHistory.type == 18 ? 'Relationship Added' : (ErHistory.type == 1 ? (ErHistory.field_name == 'New Issue' ?'New Issue':'New ER Added') : (ErHistory.type == 0 && ErHistory.field_name == 'summary' ? 'Title Updated' : (ErHistory.type == 0 && ErHistory.field_name == 'category' ? 'Category Updated' : (ErHistory.type == 0 && ErHistory.field_name == 'priority' ? 'Priority Updated' : (ErHistory.type == 0 && ErHistory.field_name == 'handler_id' ? 'Assigned To' : (ErHistory.type == 0 && ErHistory.field_name == 'Product Line' ? 'POD Updated' : (ErHistory.type == 0 && ErHistory.field_name == 'Team' ? 'Team Updated' : (ErHistory.type == 0 && ErHistory.field_name == 'status' ? 'Status Updated' : (ErHistory.type == 0 && ErHistory.field_name == 'Server' ? 'Server Updated' : (ErHistory.type == 0 && ErHistory.field_name == 'Type' ? 'Type Updated' : (ErHistory.type == 0 && ErHistory.field_name == 'Ticket' ? 'Ticket Updated' : (ErHistory.type == 0 && ErHistory.field_name == 'Support Level' ? 'Level Updated' : (ErHistory.type == 0 && ErHistory.field_name == 'Start Date' ? 'Start Date Updated' : (ErHistory.type == 0 && ErHistory.field_name == 'DEV ETA' ? 'End Date Updated' : (ErHistory.type == 0 && ErHistory.field_name == 'Go-Live Date' ? 'Go-Live Updated' : (ErHistory.type == 0 && ErHistory.field_name == 'OS Version' ? 'OS Version Updated' : (ErHistory.type == 0 && ErHistory.field_name == 'Browser' ? 'Browser Updated' : (ErHistory.type == 0 && ErHistory.field_name == 'Browser Version' ? 'Browser Version Updated' : (ErHistory.type == 19 ? 'Relationship Deleted' : (ErHistory.type == 20 ? 'Issue Cloned : ' + (ErHistory.new_value ? ErHistory.new_value : '') : (ErHistory.type == 10 ? 'File Deleted : ' + (ErHistory.old_value ? ErHistory.old_value : '') : (ErHistory.type == 12 ? 'Issue Monitored : ' + (this.state.formatted_owners[ErHistory.old_value].name ? this.state.formatted_owners[ErHistory.old_value].name : '') : (ErHistory.type == 0 && ErHistory.field_name == 'reporter' ? 'Reporter Updated' : (ErHistory.type == 21 ? 'ER Deleted' : (ErHistory.type == 0 && ErHistory.field_name == 'effort' != '' ? 'Effort Updated' : (ErHistory.type == 0 && ErHistory.field_name == 'microservice' != '' ? 'Microservice Updated' : (ErHistory.type == 0 && ErHistory.field_name == 'feature_type' != '' ? 'Feature Type Updated' : '')))))))))))))))))))))))))))))))}
                                                                            </li>
                                                                            <li class="intra_col_25">
                                                                                {ErHistory.type == 0 && ErHistory.field_name == 'effort' ?

                                                                                    (ErHistory.old_value != '' && ErHistory.old_value != 0 ? this.state.config.effort[ErHistory.old_value] : '') + ' => ' + (ErHistory.new_value != '' ? this.state.config.effort[ErHistory.new_value] : '')

                                                                                    : (ErHistory.type == 0 && ErHistory.field_name == 'Browser' ? (this.state.config.browser[ErHistory.old_value] ? this.state.config.browser[ErHistory.old_value] : '') + ' => ' + (this.state.config.browser[ErHistory.new_value] ? this.state.config.browser[ErHistory.new_value] : '')

                                                                                        : ErHistory.type == 0 && ErHistory.field_name == 'OS Version' ? (this.state.config.os_version[ErHistory.old_value] ? this.state.config.os_version[ErHistory.old_value] : '') + ' => ' + (this.state.config.os_version[ErHistory.new_value] ? this.state.config.os_version[ErHistory.new_value] : '')

                                                                                            : ErHistory.type == 0 && ErHistory.field_name == 'Server' ? (this.state.config.server[ErHistory.old_value] ? this.state.config.server[ErHistory.old_value] : '') + ' => ' + (this.state.config.server[ErHistory.new_value] ? this.state.config.server[ErHistory.new_value] : '')

                                                                                                : ErHistory.type == 0 && ErHistory.field_name == 'Product Line' ? (this.state.config.pod[ErHistory.old_value] ? this.state.config.pod[ErHistory.old_value] : '') + ' => ' + (this.state.config.pod[ErHistory.new_value] ? this.state.config.pod[ErHistory.new_value] : '')

                                                                                                    : ErHistory.type == 22 ? (ErHistory.new_value ? <a href={'/viewEr/' + ErHistory.new_value}>Added ER : {ErHistory.new_value}</a> : '')

                                                                                                        : ErHistory.type == 21 ? (ErHistory.new_value ? <a href={'/viewEr/' + ErHistory.new_value}>Related To : {ErHistory.new_value}</a> : '')

                                                                                                            : ErHistory.type == 1 ? '' : ((ErHistory.type == 6) || (ErHistory.type == 3)) ? (<Link to={`/HistoryRevision/${ErHistory.bug_id}/type/${ErHistory.type}/rev/${ErHistory.old_value}`} name={"max"} target="_blank"><span className="color-sky">View Revision</span></Link>)

                                                                                                            : (ErHistory.type == 0 && ErHistory.field_name == 'status' ? (this.state.config.all_status[ErHistory.old_value] ? this.state.config.all_status[ErHistory.old_value] : '') + ' => ' + (this.state.config.all_status[ErHistory.new_value] ? this.state.config.all_status[ErHistory.new_value] : '')

                                                                                                                    : (ErHistory.type == 18 ? (ErHistory.new_value ? <a href={'/viewEr/' + ErHistory.new_value}>Related To : {ErHistory.new_value}</a> : '') : (ErHistory.type == 19 ? (ErHistory.new_value ? <a href={'/viewEr/' + ErHistory.new_value}>Related To : {ErHistory.new_value}</a> : '')

                                                                                                                        : (ErHistory.type == 0 && ErHistory.field_name == "Go-Live Date" ? ((ErHistory.old_value) ? (ErHistory.old_value).split("-").reverse().join("-") + ' => ' : '') + ((ErHistory.new_value) ? (ErHistory.new_value).split("-").reverse().join("-") : '')

                                                                                                                            : (ErHistory.type == 0 && ErHistory.field_name == "Start Date" ? ((ErHistory.old_value) ? (ErHistory.old_value).split("-").reverse().join("-") + ' => ' : '') + ((ErHistory.new_value) ? (ErHistory.new_value).split("-").reverse().join("-") : '')

                                                                                                                                : (ErHistory.type == 0 && ErHistory.field_name == 'DEV ETA' ? ((ErHistory.old_value) ? (ErHistory.old_value).split("-").reverse().join("-") + ' => ' : '') + ((ErHistory.new_value) ? (ErHistory.new_value).split("-").reverse().join("-") : '')


                                                                                                                                    : (ErHistory.type == 0 && ErHistory.field_name == 'category' ? (this.state.config.category[ErHistory.old_value] ? this.state.config.category[ErHistory.old_value] : '') + ' => ' + (this.state.config.category[ErHistory.new_value] ? this.state.config.category[ErHistory.new_value] : '')

                                                                                                                                        : (ErHistory.type == 0 && ErHistory.field_name == 'priority' ? (this.state.config.priority[ErHistory.old_value] ? this.state.config.priority[ErHistory.old_value] : '') + ' => ' + (this.state.config.priority[ErHistory.new_value] ? this.state.config.priority[ErHistory.new_value] : '')

                                                                                                                                            : (ErHistory.type == 0 && ErHistory.field_name == 'Type' ? (this.state.config.type[ErHistory.old_value] ? this.state.config.type[ErHistory.old_value] : '') + ' => ' + (this.state.config.type[ErHistory.new_value] ? this.state.config.type[ErHistory.new_value] : '')


                                                                                                                                                : (ErHistory.type == 0 && ErHistory.field_name == 'handler_id' ? (this.state.formatted_owners[ErHistory.old_value] ? this.state.formatted_owners[ErHistory.old_value].name ? this.state.formatted_owners[ErHistory.old_value].name : '' : '') + ' => ' + (this.state.formatted_owners[ErHistory.new_value].name ? this.state.formatted_owners[ErHistory.new_value].name : '')

                                                                                                                                                    : (ErHistory.type == 0 && ErHistory.field_name == 'summary' ? (ErHistory.old_value ? ErHistory.old_value : '') + ' => ' + (ErHistory.new_value ? ErHistory.new_value : '')

                                                                                                                                                        : (ErHistory.type == 0 && ErHistory.field_name == 'reporter' ? (this.state.formatted_owners[ErHistory.old_value].name ? this.state.formatted_owners[ErHistory.old_value].name : '') + ' => ' + (this.state.formatted_owners[ErHistory.new_value].name ? this.state.formatted_owners[ErHistory.new_value].name : '')

                                                                                                                                                            : (ErHistory.type == 2 ? '' : (ErHistory.type == 12 ? '' : (ErHistory.type == 9 ? '' : (ErHistory.type == 0 && ErHistory.field_name == 'microservice' ? this.state.config.microservice[ErHistory.old_value] + ' => ' + this.state.config.microservice[ErHistory.new_value]

                                                                                                                                                                : (ErHistory.type == 0 && ErHistory.field_name == 'feature_type' ? (ErHistory.old_value == 1 ? 'Major Feature' : (ErHistory.old_value == 2 ? 'Native(Mobile/TV)' : (ErHistory.old_value == 3 ? 'Platform' : ''))) + ' => ' + (ErHistory.new_value == 1 ? 'Major Feature' : (ErHistory.new_value == 2 ? 'Native(Mobile/TV)' : (ErHistory.new_value == 3 ? 'Platform' : ''))) : ''))))))))))))))))))}
                                                                            </li>
                                                                        </div>}
                                                                </ul>
                                                            )
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3 col-xs-12">
                                    <div class="form-section">
                                        <div class="er_title">Members</div>
                                        <div class="details er_member">
                                            <div class="details_title">Reporter </div>
                                            <div class="details_des">{this.getReporter()}</div>
                                        </div>
                                        <div class="details er_member">
                                            <div class="details_title">Assign To </div>
                                            <div class="details_des">{this.getAssignedTo()}</div>
                                        </div>
                                        <div class="details er_member">
                                            <div class="details_title">Monitoring </div>
                                            <div class="details_des">
                                                {
                                                    this.state.monitor_er.map((data, key) =>
                                                        <div class="tooltips">
                                                            <div class="tooltiptext">{data.name}</div>
                                                            <div onClick={() => this.deleteMonitor(data.id, data.name)} class="er_image pull-left">
                                                                {data.attachment ? <img src={data.attachment_url + data.attachment} data-toggle="tooltip" title={data.name} /> : <span class="profile_first_name">{data.img_name}</span>}
                                                                <span class="moniter_close"><i class="fal fa-times"></i></span>
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                                <div class="add_moniter"><i class="fal fa-plus"></i></div>
                                                <div class="add_moniter_box">
                                                    <div class="selectOptions">
                                                        <MuiThemeProvider muiTheme={getMuiTheme()}>
                                                            <SelectField
                                                                multiple
                                                                fullWidth={true}
                                                                value={this.state.value}
                                                                onChange={this.handleChange}
                                                                maxHeight={200}
                                                            >
                                                                {this.state.owners.map((data, i) =>
                                                                    <MenuItem
                                                                        value={data.id} key={data.id} primaryText={data.name} />)}
                                                            </SelectField>
                                                        </MuiThemeProvider>
                                                        <div class="clear"></div>
                                                        <div style={{ color: "red" }}>{this.state.errors["monitor"]}</div>
                                                        <button class="btn btn-blue" type="submit" onClick={() => this.InsertMonitorER()}>Add</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {this.state.er.category != 13 ? <div class={this.state.er.is_flag == 0 ? 'details er_member flag' : 'details er_member flagged'}   >
                                            <div class="details_title">{this.state.er.is_flag == 0 ? 'Add To Backlog' : 'Added To Backlog'}</div>
                                            <div class="details_des">
                                                <span class="edit tooltips">
                                                    {this.state.er.is_flag == 1 && this.state.er.status == 50 ? <div class="tooltiptext">{'Added To Backlog'}</div> : (this.state.er.is_flag == 0 && this.state.er.status == 50 ? <div class="tooltiptext">{'Add To Backlog'}</div> : (this.state.er.status != 50 ? <div class="tooltiptext">{'Please select the status as Assigned'}</div> : ''))}
                                                    <span class="er_flag" data-toggle={"tooltip"}>
                                                        <i class="fa fa-flag" data-toggle="modal" data-target={this.state.er.status == 50 && this.state.er.is_flag == 1 ? '#is_flag_remove' : this.state.er.status == 50 && this.state.er.is_flag == 0 ? "#is_flag_true" : (this.state.er.status != 50 ? "" : "")} style={{ color: this.getFlagColor(this.state.er.is_flag) }} aria-hidden="true"></i>
                                                    </span>
                                                </span>
                                            </div>
                                        </div> : ''}
                                    </div>
                                    <div class="form-section date">
                                        <div class="details er_member">
                                            <div style={{fontSize:"14px",borderBottom:"1px solid #f5f5f5", paddingBottom:"10px", marginBottom:"15px"}}>
                                                <div class="details_title" style={{width:"45%"}}>Project Plan Date </div>
                                                <div class="details_des" style={{width:"55%"}}>
                                                    <span class="edit">
                                                        <span class="er_flag" >
                                                        <a href="#" data-toggle="modal" data-target="#changeProjectDates"><i class="fa fa-edit fa-1x"></i></a>
                                                        </span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="details er_member">
                                            <div class="details_title">Submitted Date </div>
                                            <div class="details_des">{this.state.er.created_date ? this.state.er.created_date : ''}</div>
                                        </div>
                                        <div class="details er_member edit_calender">
                                            <div class="details_title">Start Date </div>
                                            <div class="details_des">{this.state.er.start_date ? this.state.er.start_date : '--'}</div>
                                        </div>
                                        <div class="details er_member edit_calender">
                                            <div class="details_title">End Date </div>
                                            <div class="details_des">{this.state.er.end_date ? this.state.er.end_date : '--'}</div>
                                        </div>
                                        <div class="details er_member edit_calender">
                                            <div class="details_title">Go Live Date </div>
                                            <div class="details_des">{this.state.er.go_live_date ? this.state.er.go_live_date : '--'}</div>
                                        </div>
                                    </div>
                                    <div class="form-section">
                                        <div class="er_title">Attached File</div>
                                        <div class="details er_member">
                                            {this.state.er_attachment.map((data, key) =>
                                                <div class="attach_wrapper">
                                                    <div class={'icon icon-' + this.getImageTypeClass(data.attachment_name)}>
                                                        {this.getImageTypeClass(data.attachment_name)}
                                                    </div>
                                                    <div class="file_name text-inded">
                                                        {data.attachment_name}
                                                        <div class="file_size">
                                                            <span>{this.getSize(data.size, 2)} &emsp;</span>
                                                            <span>{data.created_date}</span>
                                                        </div>
                                                    </div>
                                                    <div class="edit_delete">
                                                        <span class="icon_download" onClick={() => this.showImage(data.url, data.attachment_name)}  >
                                                            <i class="fas fa-arrow-circle-down"></i>
                                                        </span>
                                                        <span class="icon_delete" onClick={() => this.delteimage(data.id, data.entity_id)}  >
                                                            <i class="fa fa-trash"></i>
                                                        </span>
                                                    </div>
                                                </div>
                                            )}
                                            <div class="details_des">
                                                {this.state.er.attachments ?
                                                    <div class="details_des"><span class="color-sky">{
                                                        this.state.er.attachments.split(",").map(place =>
                                                            <p>
                                                                <span onClick={() => this.showImage(this.state.er.attachment_url, place)}>
                                                                    {place}
                                                                </span>
                                                                <span class="color-red" onClick={() => this.delteimage(this.state.er.attachment_url, place)}  >
                                                                    <i class="fa fa-trash"></i>
                                                                </span>
                                                            </p>)
                                                    }</span>
                                                    </div> : ''}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            
            {/* Er 66487: New ER status& workflow, popup for adding mandatory note on Pause button */}
            <div class="modal fade" id="ChangeErToPaused" role="dialog">
                    <div class="modal-dialog modal-md">
                        <div class="modal-content">
                            <div class="modal-header">
                                <button type="button" class="close" data-dismiss="modal">&times;</button>
                                <h4 style={{ color: "black" }} class="modal-title">Are you sure want to Pause: ER {this.state.er.id}?</h4>
                            </div>
                            <div class="modal-body">
                                <input type="hidden" value={this.state.er.id} name="er_id" onChange={this.onChange} />
                                <input type="hidden" value={this.state.userId} name="user_id" onChange={this.onChange} />
                                <br />
                                <label>Leave a Reason here:<span class="star">*</span></label>
                                <div className="form-section ckeditor">
                                    <CKEditor
                                        activeClass="p10"
                                        name='note'
                                        content={this.state.note}
                                        events={{
                                            "change": this.ckOnChange1
                                        }}
                                    />
                                    <div id='note_autoseggestion'></div>
                                    <span style={{ color: "red" }}>{this.state.errors["reason_error"]}</span>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-blue" data-dismiss="modal">Cancel</button>
                                <button type="button" id= "btn_change_er_pause" class="btn btn-sky" onClick={() => this.ChangeErToPaused()}>Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Er 66487: Pause popup end */}
                {/* Er 66527: Project dates popup */}
                <div class="modal fade" id="changeProjectDates" role="dialog">
                    <div class="modal-dialog modal-md">
                        <div class="modal-content">
                            <div class="modal-header">
                                <button type="button" class="close" data-dismiss="modal">&times;</button>
                                <h4 style={{ color: "black" }} class="modal-title">Project Plan Dates: ER #{this.state.er.id}</h4>
                            </div>
                            <div class="modal-body">
                                <input type="hidden" value={this.state.er.id} name="er_id" onChange={this.onChange} />
                                <input type="hidden" value={this.state.userId} name="user_id" onChange={this.onChange} />
                                <div class="form-group col-sm-4 col-xs-6 icon-live icon-date">
                                <label>Start Date</label>
                                <div class="filter right">
                                    <DatePicker
                                        selected={this.state.startdate}
                                        onChange={this.startdateChange}
                                        autoComplete='off'
                                        placeholderText="Start Date"
                                        dateFormat="DD/MM/YYYY"
                                        peekNextMonth
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        minDate={this.state.createddate}
                                        maxDate={this.state.enddate ? this.state.enddate : (this.state.golivedate ? this.state.golivedate : '')}
                                        onBlur={event => this.focousOutStartDate(event.target.value)}
                                        readOnly={true}
                                        id ="start_date"
                                    />
                                </div>
                            </div>
                            <div class="form-group col-sm-4 col-xs-6 icon-live icon-date">
                                <label>End Date</label>
                                <div class="filter right">
                                    <DatePicker
                                        selected={this.state.enddate}
                                        onChange={this.enddateChange}
                                        autoComplete='off'
                                        placeholderText="End Date"
                                        dateFormat="DD/MM/YYYY"
                                        peekNextMonth
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        minDate={this.state.startdate ? this.state.startdate : (this.state.createddate ? this.state.createddate : '')}
                                        maxDate={this.state.golivedate}
                                        onBlur={event => this.focousOutEndDate(event.target.value)}
                                        readOnly={true}
                                        id="end_date"
                                    />
                                </div>

                            </div>
                            <div class="form-group col-sm-4 col-xs-6 icon-live icon-date">
                                <label>Go-live Date</label>
                                <div class="filter right">
                                    <DatePicker
                                        selected={this.state.golivedate}
                                        onChange={this.golivedateChange}
                                        autoComplete='off'
                                        placeholderText="Go Live Date"
                                        dateFormat="DD/MM/YYYY"
                                        peekNextMonth
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        minDate={this.state.enddate ? this.state.enddate : (this.state.startdate ? this.state.startdate : (this.state.createddate ? this.state.createddate : ''))}
                                        onBlur={event => this.focousOutGoLiveDate(event.target.value)}
                                        readOnly={true}
                                        id = "go_live_date"
                                    />
                                </div>
                            </div>
                            <br />
                            {((this.state.er.start_date != null)||(this.state.er.end_date != null)||(this.state.er.go_live_date != null)) ?
                                <div class="edit_project_dates">
                                    <label>Leave a Reason here:<span class="star">*</span></label>
                                    <div className="form-section ckeditor">
                                        <CKEditor
                                            activeClass="p10"
                                            name='note'
                                            content={this.state.note}
                                            events={{
                                                "change": this.ckOnChange1
                                            }}
                                        />
                                        <div id='note_autoseggestion'></div>
                                        <span style={{ color: "red" }}>{this.state.errors["reason_msg"]}</span>
                                    </div>
                                </div>:<div><br /><br /><br /></div>}
                             
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-blue" data-dismiss="modal">Cancel</button>
                                <button type="button" id= "btn_change_dates" class="btn btn-sky" onClick={() => this.changeProjectDates()}>Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Er 66487: Project dates popup end */}

            </div>
        )
    }
}

export default ViewErTest;


// WEBPACK FOOTER //
// ./src/components/er/viewErTest.js